<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- Job Details -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="media col-lg-6">
                <img src="/img/img-1.cd1a7cd0.png" alt class="avatar-sm mr-4" />

                <div class="media-body overflow-hidden">
                  <div class="float-left">
                    <h5 class="text-truncate font-size-15">
                      Job # {{ jobNum }}
                    </h5>
                    <p class="text-muted">
                      {{ jobCustomer }}
                    </p>
                  </div>
                  <div class="float-left ml-4">
                    <h5 class="font-size-14">
                      <i class="bx bx-calendar-check mr-1 text-primary"></i>
                      Date
                    </h5>
                    <p class="text-muted mb-0">
                      {{ jobDate }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 mb-4 mb-lg-0">
                <!-- Put the edit, delete, etc.. buttons here. -->
                <b-dropdown dropleft class="float-right ml-2" variant="primary">
                  <template v-slot:button-content>
                    <i class="mdi mdi-chevron-down"></i>
                  </template>
                  <b-dropdown-item
                    v-b-modal.modal_editJob
                    @click="editJob(jobCustomer, jobDate, jobDesc)"
                    ><i class="bx bx-pencil mr-2 tableIcons"></i>Edit
                    Job</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-b-modal.modal_editBudgets
                    @click="jobBudgetEditComplete = false"
                    ><i class="bx bx-error-circle mr-2 tableIcons"></i>Edit
                    Budgets</b-dropdown-item
                  >
                  <b-dropdown-item @click="completeJob('dropdown')"
                    ><i
                      class="bx mr-2 tableIcons"
                      :class="!jobComplete ? 'bx-check-circle' : 'bx-x'"
                    ></i
                    >Mark Job as {{ jobComplete ? 'Incomplete' : 'Complete' }}
                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="deleteJob()"
                    ><i class="bx bx-trash mr-2 tableIcons"></i>Delete
                    Job</b-dropdown-item
                  >
                </b-dropdown>
                <b-button
                  variant="primary"
                  v-b-modal.modal_createInvoice
                  class="btn btn-label btn-primary ml-2 float-right"
                  ><i class="bx bx-file label-icon"></i>Create Invoice</b-button
                >
                <div class="float-right mr-4 text-center">
                  Job {{ jobComplete ? 'Complete' : 'Incomplete' }}
                  <b-form-checkbox
                    switch
                    class="mb-3 completeSwitch"
                    v-model="jobComplete"
                    disabled
                  >
                  </b-form-checkbox>
                </div>
              </div>
            </div>
            <!--/Row-->

            <h5 class="font-size-15 mt-4">Project Details :</h5>

            <p class="text-muted">
              {{ jobDesc }}
            </p>
            <div v-if="supervisor">
              <h5 class="font-size-15 mt-4">Supervisor :</h5>
              <p class="text-muted">
                {{ supervisor.name }}
              </p>
            </div>
            <div v-if="jobDepartment">
              <h5 class="font-size-15 mt-4">Department :</h5>
              <p class="text-muted">
                {{ jobDepartment }}
              </p>
            </div>
            <div v-if="jobType">
              <h5 class="font-size-15 mt-4">Job Type :</h5>
              <p v-if="jobType === 'Quoted (Fixed Rate)'" class="text-muted">
                {{ jobType }} : ${{ jobQuote }}
              </p>
              <p v-else class="text-muted">{{ jobType }}</p>
            </div>

            <div v-if="controlsEnabled">
              <h5 class="font-size-15 mt-4">Job Controls:</h5>
              <h5>
                <b-badge
                  v-if="jobDetailsLoaded"
                  @click="showBudgets = !showBudgets"
                  variant="info"
                  class="mb-2"
                  role="button"
                >
                  {{ showBudgets ? 'Hide' : 'Show More' }}
                </b-badge>
                <b-badge
                  v-if="showBudgets"
                  v-b-modal.modal_editBudgets
                  variant="primary"
                  class="mb-2 ml-2"
                  role="button"
                  @click="jobBudgetEditComplete = false"
                >
                  Edit Budgets
                </b-badge>
                <b-badge
                  v-if="showBudgets && budgetRevisions.length > 0"
                  style="cursor: pointer"
                  class="mb-2 ml-2"
                  :variant="showBudgetRevisions ? 'danger' : 'light'"
                  @click="
                    () => {
                      showBudgetRevisions = !showBudgetRevisions;
                    }
                  "
                  >{{
                    showBudgetRevisions ? 'Hide Revisions' : 'View Revisions'
                  }}</b-badge
                >
              </h5>
              <div v-if="showBudgetRevisions && showBudgets" class="mb-2">
                <div
                  v-for="(revision, revisionIndex) in budgetRevisions"
                  :key="revisionIndex"
                >
                  <div class="media">
                    <i class="bx bx-right-arrow-circle font-size-18 mr-2"></i>

                    <div class="mr-3">
                      <h5 class="font-size-14">
                        {{ formatDates(revision.date) }}
                        <i
                          class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                        ></i>
                      </h5>
                    </div>
                    <div class="media-body">
                      <div>
                        {{ getRevisionString(revision) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Job budget -->
              <div v-if="jobBudget && jobBudgetEditComplete">
                <table v-if="showBudgets" class="table text-center">
                  <thead class="table-light">
                    <tr>
                      <td>Enabled</td>
                      <td>Name</td>
                      <td>Type</td>
                      <td>Unit of Measure</td>
                      <td>Progress</td>
                      <td>Current</td>
                      <td>Budget</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <i class="bx bx-check-circle text-success h4"></i>
                      </td>
                      <td>Flat Rate Budget</td>
                      <td>Dollar Amount</td>
                      <td>Billable Rates & Marked-up Amounts</td>
                      <td>
                        <div
                          v-b-tooltip.hover
                          :title="`${(
                            ((procurementControls['materials'].current[
                              'Marked-up Amount'
                            ] +
                              procurementControls['other'].current[
                                'Marked-up Amount'
                              ] +
                              procurementControls['rentals'].current[
                                'Marked-up Amount'
                              ] +
                              procurementControls['thirdParty'].current[
                                'Marked-up Amount'
                              ] +
                              controls['labour'].current +
                              controls['products'].current) /
                              jobBudget) *
                            100
                          ).toFixed(2)}% used (${
                            procurementControls['materials'].current[
                              'Marked-up Amount'
                            ] +
                            procurementControls['other'].current[
                              'Marked-up Amount'
                            ] +
                            procurementControls['rentals'].current[
                              'Marked-up Amount'
                            ] +
                            procurementControls['thirdParty'].current[
                              'Marked-up Amount'
                            ] +
                            controls['labour'].current +
                            controls['products'].current
                          } / ${jobBudget})`"
                        >
                          <b-progress
                            :value="
                              procurementControls['materials'].current[
                                'Marked-up Amount'
                              ] +
                              procurementControls['other'].current[
                                'Marked-up Amount'
                              ] +
                              procurementControls['rentals'].current[
                                'Marked-up Amount'
                              ] +
                              procurementControls['thirdParty'].current[
                                'Marked-up Amount'
                              ] +
                              controls['labour'].current +
                              controls['products'].current
                            "
                            :max="jobBudget"
                            class="mb-4"
                            :variant="
                              (procurementControls['materials'].current[
                                'Marked-up Amount'
                              ] +
                                procurementControls['other'].current[
                                  'Marked-up Amount'
                                ] +
                                procurementControls['rentals'].current[
                                  'Marked-up Amount'
                                ] +
                                procurementControls['thirdParty'].current[
                                  'Marked-up Amount'
                                ] +
                                controls['labour'].current +
                                controls['products'].current) /
                                jobBudget >=
                              1
                                ? 'danger'
                                : (procurementControls['materials'].current[
                                    'Marked-up Amount'
                                  ] +
                                    procurementControls['other'].current[
                                      'Marked-up Amount'
                                    ] +
                                    procurementControls['rentals'].current[
                                      'Marked-up Amount'
                                    ] +
                                    procurementControls['thirdParty'].current[
                                      'Marked-up Amount'
                                    ] +
                                    controls['labour'].current +
                                    controls['products'].current) /
                                    jobBudget <
                                    1 &&
                                  (procurementControls['materials'].current[
                                    'Marked-up Amount'
                                  ] +
                                    procurementControls['other'].current[
                                      'Marked-up Amount'
                                    ] +
                                    procurementControls['rentals'].current[
                                      'Marked-up Amount'
                                    ] +
                                    procurementControls['thirdParty'].current[
                                      'Marked-up Amount'
                                    ] +
                                    controls['labour'].current +
                                    controls['products'].current) /
                                    jobBudget >=
                                    0.8
                                ? 'warning'
                                : 'success'
                            "
                          ></b-progress>
                        </div>
                      </td>
                      <td>
                        <span>
                          {{
                            !isNaN(
                              procurementControls['materials'].current[
                                'Marked-up Amount'
                              ] +
                                procurementControls['other'].current[
                                  'Marked-up Amount'
                                ] +
                                procurementControls['rentals'].current[
                                  'Marked-up Amount'
                                ] +
                                procurementControls['thirdParty'].current[
                                  'Marked-up Amount'
                                ] +
                                controls['labour'].current +
                                controls['products'].current
                            )
                              ? procurementControls['materials'].current[
                                  'Marked-up Amount'
                                ] +
                                procurementControls['other'].current[
                                  'Marked-up Amount'
                                ] +
                                procurementControls['rentals'].current[
                                  'Marked-up Amount'
                                ] +
                                procurementControls['thirdParty'].current[
                                  'Marked-up Amount'
                                ] +
                                controls['labour'].current +
                                controls['products'].current
                              : ''
                          }}
                        </span>
                      </td>
                      <td>{{ jobBudget }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /Job budget -->
              <!-- Cetgory job budgets -->
              <div v-else>
                <table
                  v-if="showBudgets && jobBudgetEditComplete"
                  class="table text-center"
                >
                  <thead class="table-light">
                    <tr>
                      <td>Enabled</td>
                      <td>Name</td>
                      <td>Type</td>
                      <td>Unit of Measure</td>
                      <td>Progress</td>
                      <td>Current</td>
                      <td>Budget</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(control, index) in controls"
                      :key="index"
                      :style="
                        !control.active
                          ? 'background-color: lightgray;opacity: 0.4;'
                          : ''
                      "
                    >
                      <td>
                        <i
                          v-if="control.active"
                          class="bx bx-check-circle text-success h4"
                        ></i>
                      </td>
                      <td>
                        {{ control.name }}
                      </td>
                      <td>{{ control.type }}</td>
                      <td>{{ control.unitOfMeasure }}</td>
                      <td>
                        <div
                          v-if="
                            control.active && control.name != 'Procurements'
                          "
                          v-b-tooltip.hover
                          :title="`${(
                            (control.current / control.value) *
                            100
                          ).toFixed(2)}% used (${control.current} / ${
                            control.value
                          })`"
                        >
                          <b-progress
                            :value="control.current"
                            :max="control.value"
                            class="mb-4"
                            :variant="
                              control.current / control.value >= 1
                                ? 'danger'
                                : control.current / control.value < 1 &&
                                  control.current / control.value >= 0.8
                                ? 'warning'
                                : 'success'
                            "
                          ></b-progress>
                        </div>
                        <div
                          v-if="
                            control.active && control.name == 'Procurements'
                          "
                          v-b-tooltip.hover
                          :title="`${(
                            ((procurementControls['materials'].current[
                              controls['procurements'].unitOfMeasure
                            ] +
                              procurementControls['other'].current[
                                controls['procurements'].unitOfMeasure
                              ] +
                              procurementControls['rentals'].current[
                                controls['procurements'].unitOfMeasure
                              ] +
                              procurementControls['thirdParty'].current[
                                controls['procurements'].unitOfMeasure
                              ]) /
                              control.value) *
                            100
                          ).toFixed(2)}% used (${
                            procurementControls['materials'].current[
                              controls['procurements'].unitOfMeasure
                            ] +
                            procurementControls['other'].current[
                              controls['procurements'].unitOfMeasure
                            ] +
                            procurementControls['rentals'].current[
                              controls['procurements'].unitOfMeasure
                            ] +
                            procurementControls['thirdParty'].current[
                              controls['procurements'].unitOfMeasure
                            ]
                          } / ${control.value})`"
                        >
                          <b-progress
                            :value="
                              procurementControls['materials'].current[
                                controls['procurements'].unitOfMeasure
                              ] +
                              procurementControls['other'].current[
                                controls['procurements'].unitOfMeasure
                              ] +
                              procurementControls['rentals'].current[
                                controls['procurements'].unitOfMeasure
                              ] +
                              procurementControls['thirdParty'].current[
                                controls['procurements'].unitOfMeasure
                              ]
                            "
                            :max="control.value"
                            class="mb-4"
                            :variant="
                              (procurementControls['materials'].current[
                                controls['procurements'].unitOfMeasure
                              ] +
                                procurementControls['other'].current[
                                  controls['procurements'].unitOfMeasure
                                ] +
                                procurementControls['rentals'].current[
                                  controls['procurements'].unitOfMeasure
                                ] +
                                procurementControls['thirdParty'].current[
                                  controls['procurements'].unitOfMeasure
                                ]) /
                                control.value >=
                              1
                                ? 'danger'
                                : (procurementControls['materials'].current[
                                    controls['procurements'].unitOfMeasure
                                  ] +
                                    procurementControls['other'].current[
                                      controls['procurements'].unitOfMeasure
                                    ] +
                                    procurementControls['rentals'].current[
                                      controls['procurements'].unitOfMeasure
                                    ] +
                                    procurementControls['thirdParty'].current[
                                      controls['procurements'].unitOfMeasure
                                    ]) /
                                    control.value <
                                    1 &&
                                  (procurementControls['materials'].current[
                                    controls['procurements'].unitOfMeasure
                                  ] +
                                    procurementControls['other'].current[
                                      controls['procurements'].unitOfMeasure
                                    ] +
                                    procurementControls['rentals'].current[
                                      controls['procurements'].unitOfMeasure
                                    ] +
                                    procurementControls['thirdParty'].current[
                                      controls['procurements'].unitOfMeasure
                                    ]) /
                                    control.value >=
                                    0.8
                                ? 'warning'
                                : 'success'
                            "
                          ></b-progress>
                        </div>
                      </td>
                      <td>
                        <span v-if="control.name != 'Procurements'">
                          {{ !isNaN(control.current) ? control.current : '' }}
                        </span>
                        <span v-else>
                          {{
                            !isNaN(
                              procurementControls['materials'].current[
                                controls['procurements'].unitOfMeasure
                              ] +
                                procurementControls['other'].current[
                                  controls['procurements'].unitOfMeasure
                                ] +
                                procurementControls['rentals'].current[
                                  controls['procurements'].unitOfMeasure
                                ] +
                                procurementControls['thirdParty'].current[
                                  controls['procurements'].unitOfMeasure
                                ]
                            )
                              ? procurementControls['materials'].current[
                                  controls['procurements'].unitOfMeasure
                                ] +
                                procurementControls['other'].current[
                                  controls['procurements'].unitOfMeasure
                                ] +
                                procurementControls['rentals'].current[
                                  controls['procurements'].unitOfMeasure
                                ] +
                                procurementControls['thirdParty'].current[
                                  controls['procurements'].unitOfMeasure
                                ]
                              : ''
                          }}
                        </span>
                      </td>
                      <td>{{ control.value }}</td>
                    </tr>
                  </tbody>
                </table>
                <table
                  v-if="
                    showBudgets &&
                    controls.procurements.active &&
                    jobBudgetEditComplete
                  "
                  class="table text-center"
                >
                  <thead>
                    <tr class="table-light">
                      <td>Enabled</td>
                      <td>Name</td>
                      <td>Type</td>
                      <td>Unit of Measure</td>
                      <td>Progress</td>
                      <td>Current</td>
                      <td>Budget</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(control, index) in procurementControls"
                      :key="index"
                      :style="
                        !control.active
                          ? 'background-color: lightgray;opacity: 0.4;'
                          : ''
                      "
                    >
                      <td>
                        <i
                          v-if="control.active"
                          class="bx bx-check-circle text-success h4"
                        ></i>
                      </td>
                      <td>
                        {{ control.name }}
                      </td>
                      <td>{{ control.type }}</td>
                      <td>{{ control.unitOfMeasure }}</td>
                      <td>
                        <div
                          v-if="control.active"
                          v-b-tooltip.hover
                          :title="`${(
                            (control.current[control.unitOfMeasure] /
                              control.value) *
                            100
                          ).toFixed(2)}% used (${
                            control.current[control.unitOfMeasure]
                          } / ${control.value})`"
                        >
                          <b-progress
                            :value="control.current[control.unitOfMeasure]"
                            :max="control.value"
                            class="mb-4"
                            :variant="
                              control.current[control.unitOfMeasure] /
                                control.value >=
                              1
                                ? 'danger'
                                : control.current[control.unitOfMeasure] /
                                    control.value <
                                    1 &&
                                  control.current[control.unitOfMeasure] /
                                    control.value >=
                                    0.8
                                ? 'warning'
                                : 'success'
                            "
                          ></b-progress>
                        </div>
                      </td>
                      <td>
                        {{
                          !isNaN(control.current[control.unitOfMeasure])
                            ? control.current[control.unitOfMeasure]
                            : ''
                        }}
                      </td>
                      <td>{{ control.value }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /Category job budgets -->
            </div>

            <div class="row task-dates"></div>

            <b-modal
              id="modal_createInvoice"
              title="Create Invoice"
              title-class="font-18"
              ok-title="Submit"
              @ok="submitCreateInvoice"
            >
              <div class="row">
                <div class="col-6">
                  <div class="mb-4">
                    <div class="form-group">
                      <label>Start Date</label>
                      <date-picker
                        v-model="createInvoice_startDate"
                        :first-day-of-week="1"
                        lang="en"
                        placeholder="Date..."
                        format="MMM DD, YY"
                        :class="{
                          'is-invalid': createInvoice_errors.startDateError,
                        }"
                        :input-class="{
                          'form-control mx-input date-is-invalid':
                            createInvoice_errors.startDateError,
                          'form-control mx-input':
                            !createInvoice_errors.startDateError,
                        }"
                      ></date-picker>
                      <div
                        v-if="createInvoice_errors.startDateError"
                        class="invalid-feedback"
                      >
                        <span>{{ createInvoice_errors.startDateMessage }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="mb-4">
                    <div class="form-group">
                      <label>End Date</label>
                      <date-picker
                        v-model="createInvoice_endDate"
                        :first-day-of-week="1"
                        lang="en"
                        placeholder="Date..."
                        format="MMM DD, YY"
                        :class="{
                          'is-invalid': createInvoice_errors.endDateError,
                        }"
                        :input-class="{
                          'form-control mx-input date-is-invalid':
                            createInvoice_errors.endDateError,
                          'form-control mx-input':
                            !createInvoice_errors.endDateError,
                        }"
                      ></date-picker>
                      <div
                        v-if="createInvoice_errors.endDateError"
                        class="invalid-feedback"
                      >
                        <span>{{ createInvoice_errors.endDateMessage }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>

            <b-modal
              id="modal_editJob"
              title="Edit Job"
              title-class="font-18"
              ok-title="Submit"
              size="lg"
              @ok="submitJobEdit"
            >
              <div class="mt-4 mt-lg-0 mb-4">
                <div class="form-group">
                  <label>Customer</label>
                  <v-select
                    :options="customers"
                    label="employee"
                    v-model="editJob_selectedCustomer"
                    :class="{
                      'is-invalid ddl-is-invalid': editJob_errors.customerError,
                    }"
                    transition=""
                  ></v-select>
                  <div
                    v-if="editJob_errors.customerError"
                    class="invalid-feedback"
                  >
                    <span>{{ editJob_errors.customerMessage }}</span>
                  </div>
                </div>
              </div>
              <div class="mb-4">
                <div class="form-group">
                  <label>Date</label>
                  <date-picker
                    v-model="editJob_date"
                    :first-day-of-week="1"
                    lang="en"
                    placeholder="Date..."
                    format="MMM DD, YY"
                    :class="{
                      'is-invalid': editJob_errors.dateError,
                    }"
                    :input-class="{
                      'form-control mx-input date-is-invalid':
                        editJob_errors.dateError,
                      'form-control mx-input': !editJob_errors.dateError,
                    }"
                  ></date-picker>
                  <div v-if="editJob_errors.dateError" class="invalid-feedback">
                    <span>{{ editJob_errors.dateMessage }}</span>
                  </div>
                </div>
              </div>
              <div class="mb-4">
                <div class="form-group">
                  <label>Description</label>
                  <textarea
                    id="projectdesc"
                    class="form-control"
                    rows="3"
                    placeholder="Enter Work Description..."
                    v-model="editJob_desc"
                    :class="{
                      'is-invalid': editJob_errors.descError,
                    }"
                  ></textarea>
                  <div v-if="editJob_errors.descError" class="invalid-feedback">
                    <span>{{ editJob_errors.descMessage }}</span>
                  </div>
                </div>
              </div>
              <div class="mt-4 mt-lg-0 mb-4">
                <div class="form-group">
                  <label>Supervisor (Optional)</label>
                  <v-select
                    :options="employeeOptions"
                    label="name"
                    v-model="editJob_supervisor"
                    transition=""
                  ></v-select>
                </div>
              </div>
              <div class="mt-4 mt-lg-0 mb-4">
                <div class="form-group">
                  <label>Job Type (Optional)</label>
                  <v-select
                    :options="jobTypeOptions"
                    v-model="editJob_jobType"
                    transition=""
                  ></v-select>
                </div>
              </div>
              <div class="mt-4 mt-lg-0 mb-4">
                <div class="form-group">
                  <label>Department (Optional)</label>
                  <input
                    type="text"
                    rows="1"
                    class="form-control"
                    v-model.trim="editJob_jobDepartment"
                  />
                </div>
              </div>
              <div
                v-if="editJob_jobType === 'Quoted (Fixed Rate)'"
                class="mt-4 mt-lg-0 mb-4"
              >
                <div class="form-group">
                  <label>Quoted Price</label>
                  <b-form-input
                    v-model="editJob_jobQuote"
                    @blur="
                      () => {
                        if (Number(editJob_jobQuote) > max) {
                          editJob_jobQuote = max;
                        }
                      }
                    "
                    type="number"
                    min="0"
                    max="100000000"
                  ></b-form-input>
                </div>
              </div>
              <div class="form-group">
                <label id="lbl_editJob_revenueCalculations"
                  >Revenue Calculations
                  <i class="bx bxs-help-circle"></i>
                  <b-tooltip target="lbl_editJob_revenueCalculations"
                    >Default revenue calculations will base the job's revenue
                    off of the job type. Time x Material jobs will calculate
                    revenue based off of the time, products, and procurement
                    revenue. Quoted (Fixed Rate) jobs will calculate revenue
                    based off of the specified Quoted Price in a job.
                    <br />
                    <br />
                    Invoiced Amount revenue calculations will grant the ability
                    to add invoice history to a job. The revenue calculations
                    will be based off of the total invoiced amount.</b-tooltip
                  >
                </label>
                <b-form-group>
                  <b-form-radio
                    v-for="(type, typeIndex) in revenueTypes"
                    :key="typeIndex"
                    v-model="editJob_selectedRevenueType"
                    :name="type.label"
                    :value="type.value"
                  >
                    {{ type.label }}
                  </b-form-radio>
                </b-form-group>
              </div>
              <div class="mt-4">
                <label id="lbl_jobDetails_enableFutureTimes">Allow Adding Future Times to This Job?
                  <i class="bx bxs-help-circle"></i>
                  <b-tooltip target="lbl_jobDetails_enableFutureTimes">
                    If disabled, this will not let you add times to the job where the date is set past the current date.
                  </b-tooltip>
                </label>
                <div class="form-group">
                  <switches
                      v-model="editJob_futureTimesEnabled"
                      type-bold="false"
                      color="primary"
                      class="float-left mt-2"
                    ></switches>
                </div>
              </div>
            </b-modal>

            <!-- Edit Job Budgets -->
            <b-modal
              id="modal_editBudgets"
              title="Edit Budgets"
              title-class="font-18"
              ok-title="Submit"
              size="lg"
              @ok="submitBudgetEdit"
              @hide="
                () => {
                  jobBudgetEditComplete = true;
                }
              "
            >
              <div class="mb-4">
                <label>Job Controls Enabled </label>
                <div class="col-lg-10">
                  <switches
                    v-model="editedControlsEnabled"
                    type-bold="false"
                    color="primary"
                    class="ml-1 mb-0 mt-2"
                  ></switches>
                </div>
              </div>
              <div v-if="editedControlsEnabled" class="mt-4 mt-lg-0 mb-4">
                <job-budgets
                  ref="jobBudgetsComponent"
                  :controls="editedControls"
                  :procurementControls="editedProcurementControls"
                  :categoryBudgetsEnabled="!jobBudget"
                  :jobBudget="jobBudget"
                  @jobBudgetUpdated="jobBudgetUpdated"
                ></job-budgets>
              </div>
            </b-modal>
            <!-- /Edit Job Budgets -->
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!-- end row -->

    <!-- Hours and job specific rates -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted"
            >
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="bx bxs-timer"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Billable Hours</span>
                </template>
                <div class="row mt-3">
                  <div class="col-6">
                    <h4 class="card-title">Billable Hours</h4>
                  </div>
                  <div class="col-6">
                    <div class="float-right">
                      <b-button
                        variant="primary"
                        class="btn btn-label btn-primary"
                        v-b-modal.modal_addTime
                        ><i class="bx bx-plus label-icon"></i>Add Time</b-button
                      >
                      <!-- Add Time Modal -->
                      <b-modal
                        id="modal_addTime"
                        title="Add Time"
                        title-class="font-18"
                        ok-title="Add Time"
                        @shown="showAddTimeModal"
                        @hidden="resetAddTimeModal"
                        @ok="addTime"
                      >
                        <div class="mt-4 mt-lg-0 mb-4">
                          <dynamic-controls
                            v-for="input in fieldTicketForm"
                            :key="input.index"
                            :field="input"
                            :futureDatesEnabled="futureTimesEnabled"
                            ref="fieldTicketFormFields"
                            @updateRate="updateRate"
                          >
                          </dynamic-controls>
                        </div>
                      </b-modal>
                      <!-- /Add Time Modal -->
                      <!-- Edit Time Modal -->
                      <b-modal
                        id="modal_editTime"
                        ref="modal-editTime"
                        title="Edit Time"
                        title-class="font-18"
                        ok-title="Submit"
                        @shown="showEditTimeModal"
                        @hidden="resetEditTimeModal"
                        @ok="submitEditTime"
                      >
                        <div class="mt-4 mt-lg-0 mb-4">
                          <dynamic-controls
                            v-for="input in fieldTicketFormEdit"
                            :key="input.index"
                            :field="input"
                            :futureDatesEnabled="futureTimesEnabled"
                            ref="fieldTicketFormFields"
                            @updateRate="updateRate"
                          >
                          </dynamic-controls>
                        </div>
                        <label for="hour-type-select" class="mt-0"
                          >Select Hour Type</label
                        >
                        <v-select
                          :options="hoursOptions"
                          id="hour-type-select"
                          label="hourType"
                          v-model="editTimeHourType"
                          placeholder="..."
                          @input="updateRate(null, null, null, null, true)"
                        ></v-select>
                      </b-modal>
                      <!-- /Edit Time Modal -->
                      <!-- Move Time Modal -->
                      <b-modal
                        id="modal_moveTime"
                        ref="modal-moveTime"
                        title="Move Time"
                        title-class="font-18"
                        scrollable
                        ok-only
                        ok-variant="secondary"
                        ok-title="Cancel"
                      >
                        <div class="d-block text-center">
                          <h4>Select an Incomplete Job Below</h4>
                          <p>
                            Transferring time:
                            <span class="text-info"
                              >{{ moveTimeObj.description }} -
                              {{ moveTimeObj.employee }} -
                              {{ moveTimeObj.date }}</span
                            >
                          </p>
                        </div>
                        <div
                          @click="
                            onMoveTimeToDifferentJob(
                              job.jobNum,
                              job.customer,
                              job.description
                            )
                          "
                          v-for="job in orgJobs"
                          :key="job.id"
                        >
                          <div
                            class="card border move-time-modal-card border-primary"
                            v-if="job.jobNum !== jobNum"
                          >
                            <div
                              class="card-header bg-transparent border-primary"
                            >
                              <h5 class="my-0 text-primary">
                                <i class="bx bx-right-arrow-circle me-3"></i>
                                Job # {{ job.jobNum }}
                              </h5>
                            </div>
                            <div class="p-1">
                              <ul class="move-time-modal-card-list">
                                <div class="row move-time-modal-card-row">
                                  <li class="card-text">
                                    {{ `${job.customerDisplayName}` }}
                                  </li>
                                  <li class="mx-2">|</li>
                                  <li class="card-text">
                                    {{
                                      `${momentDateFormat(job.date.toDate())}`
                                    }}
                                  </li>
                                </div>
                                <li class="row mr-2 mt-2">
                                  <strong>{{ job.description }}</strong>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </b-modal>
                      <!-- /Move Time Modal -->
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="hoursPerPage"
                          size="sm"
                          :options="hoursPageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="hoursFilter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                    :items="hoursTableData"
                    :fields="hoursFields"
                    responsiv="xl"
                    :per-page="hoursPerPage"
                    :current-page="hoursCurrentPage"
                    :sort-by.sync="hoursSortBy"
                    :sort-desc.sync="hoursSortDesc"
                    :sort-compare="tableSort"
                    :filter="hoursFilter"
                    :filter-included-fields="hoursFilterOn"
                    style="text-align: center"
                    primary-key="edit"
                  >
                    <template v-slot:cell(edit)="data">
                      <div>
                        <span :id="`hoursEdit-${data.item.edit}`">
                          <b-dropdown
                            variant="primary"
                            size="sm"
                            :disabled="data.item.approved"
                          >
                            <template v-slot:button-content>
                              <i class="mdi mdi-chevron-down"></i>
                            </template>
                            <b-dropdown-item
                              v-b-modal.modal_editTime
                              @click="
                                editTime(
                                  data.index,
                                  data.item.edit,
                                  data.item.employee,
                                  data.item.uid,
                                  data.item.hours,
                                  data.item.description
                                )
                              "
                              ><i class="bx bx-edit-alt mr-2 tableIcons"></i
                              >Edit</b-dropdown-item
                            >
                            <b-dropdown-item
                              v-b-modal.modal_moveTime
                              @click="
                                moveTime(
                                  data.item.edit,
                                  data.item.employee,
                                  data.item.date,
                                  data.item.description
                                )
                              "
                              ><i
                                class="bx bx-right-arrow-circle mr-2 tableIcons"
                              ></i
                              >Move to a Different Job</b-dropdown-item
                            >
                            <b-dropdown-item @click="deleteTime(data.item.edit)"
                              ><i class="bx bx-trash mr-2 tableIcons"></i
                              >Delete</b-dropdown-item
                            >
                          </b-dropdown>
                        </span>
                        <b-tooltip
                          :target="`hoursEdit-${data.item.edit}`"
                          triggers="hover"
                          v-if="data.item.approved"
                        >
                          Approved times cannot be edited or deleted
                        </b-tooltip>
                      </div>
                    </template>
                    <template v-slot:cell(approved)="data">
                      <div
                        :id="`hoursApproved-${data.item.edit}`"
                        style="display: inline-block"
                      >
                        <b-form-checkbox v-model="data.item.approved" @change="(newValue) => approveTime(newValue, data.item.edit)">
                        </b-form-checkbox>
                      </div>
                      <b-tooltip
                        :target="`hoursApproved-${data.item.edit}`"
                        triggers="hover"
                        v-if="data.item.approved && data.item.approvedBy"
                      >
                        {{
                          `Approved by ${
                            data.item.approvedBy.name
                          } on ${data.item.approvedTime
                            .toString()
                            .substring(0, 15)} at ${data.item.approvedTime
                            .toString()
                            .substring(16, 21)}`
                        }}
                      </b-tooltip>
                    </template>
                    <template v-slot:cell(billable)="data">
                      <div
                        :id="`hoursBillable-${data.item.edit}`"
                        style="display: inline-block"
                      >
                        <b-form-checkbox v-model="data.item.billable" @change="(newValue) => updateTimeBillable(newValue, data.item.edit)">
                        </b-form-checkbox>
                      </div>
                      <b-tooltip
                        :target="`hoursBillable-${data.item.edit}`"
                        triggers="hover"
                        v-if="
                          data.item.billable && data.item.billableApprovedBy
                        "
                      >
                        {{
                          `Excluded from billing by ${
                            data.item.billableApprovedBy.name
                          } on ${data.item.billableApprovedTime
                            .toString()
                            .substring(
                              0,
                              15
                            )} at ${data.item.billableApprovedTime
                            .toString()
                            .substring(16, 21)}`
                        }}
                      </b-tooltip>
                    </template>
                    <template v-slot:cell(type)="data">
                      <b-badge
                        :variant="
                          data.value === 'ot'
                            ? 'danger'
                            : data.value === 'tt'
                            ? 'info'
                            : 'success'
                        "
                        >{{
                          data.value === 'ot'
                            ? 'Overtime'
                            : data.value === 'tt'
                            ? 'Travel'
                            : 'Regular'
                        }}</b-badge
                      >
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-right"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="hoursCurrentPage"
                          :total-rows="hoursTotalRows"
                          :per-page="hoursPerPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="bx bxs-purchase-tag"></i>
                  </span>
                  <span class="d-none d-sm-inline-block"
                    >Billable Products</span
                  >
                </template>
                <div class="row mt-3">
                  <div class="col-6">
                    <h4 class="card-title">Billable Products</h4>
                  </div>
                  <div class="col-6">
                    <div class="float-right">
                      <b-button
                        variant="primary"
                        class="btn btn-label btn-primary"
                        v-b-modal.modal_addProduct
                        ><i class="bx bx-plus label-icon"></i>Add
                        Product</b-button
                      >
                      <!-- Add Product Modal -->
                      <b-modal
                        id="modal_addProduct"
                        title="Add Product"
                        title-class="font-18"
                        ok-title="Add Product"
                        @ok="addProduct"
                      >
                        <div class="mt-4 mt-lg-0 mb-4">
                          <dynamic-controls
                            v-for="input in productForm"
                            :key="input.index"
                            :field="input"
                            ref="productFormFields"
                            @updateProductRate="updateProductRate"
                          >
                          </dynamic-controls>
                        </div>
                      </b-modal>
                      <!-- /Add Product Modal -->
                      <!-- Edit Product Modal -->
                      <b-modal
                        id="modal_editProduct"
                        title="Edit Product"
                        title-class="font-18"
                        ok-title="Submit"
                        @shown="showEditProductModal"
                        @ok="submitEditProduct"
                      >
                        <div class="mt-4 mt-lg-0 mb-4">
                          <dynamic-controls
                            v-for="input in productForm"
                            :key="input.index"
                            :field="input"
                            ref="productFormFields"
                            @updateProductRate="updateProductRate"
                          >
                          </dynamic-controls>
                        </div>
                      </b-modal>
                      <!-- /Edit Product Modal -->
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div id="products-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="productsPerPage"
                          size="sm"
                          :options="productsPageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="products-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="productsFilter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                    :items="productsTableData"
                    :fields="productsFields"
                    responsiv="xl"
                    :per-page="productsPerPage"
                    :current-page="productsCurrentPage"
                    :sort-by.sync="productsSortBy"
                    :sort-desc.sync="productsSortDesc"
                    :sort-compare="tableSort"
                    :filter="productsFilter"
                    :filter-included-fields="productsFilterOn"
                    style="text-align: center"
                    primary-key="edit"
                  >
                    <template v-slot:cell(edit)="data">
                      <div>
                        <span :id="`productEdit-${data.item.edit}`">
                          <b-dropdown
                            variant="primary"
                            size="sm"
                            :disabled="data.item.approved"
                          >
                            <template v-slot:button-content>
                              <i class="mdi mdi-chevron-down"></i>
                            </template>
                            <b-dropdown-item
                              v-b-modal.modal_editProduct
                              @click="
                                editProduct(
                                  data.index,
                                  data.item.edit,
                                  data.item.employee,
                                  data.item.date,
                                  data.item.quantity,
                                  data.item.products
                                )
                              "
                              ><i class="bx bx-edit-alt mr-2 tableIcons"></i
                              >Edit</b-dropdown-item
                            >
                            <b-dropdown-item
                              @click="deleteProduct(data.item.edit)"
                              ><i class="bx bx-trash mr-2 tableIcons"></i
                              >Delete</b-dropdown-item
                            >
                          </b-dropdown>
                        </span>
                        <b-tooltip
                          :target="`productEdit-${data.item.edit}`"
                          triggers="hover"
                          v-if="data.item.approved"
                        >
                          Approved products cannot be edited or deleted
                        </b-tooltip>
                      </div>
                    </template>
                    <template v-slot:cell(approved)="data">
                      <div
                        :id="`productsApproved-${data.item.edit}`"
                        style="display: inline-block"
                      >
                        <b-form-checkbox v-model="data.item.approved" @change="(newValue) => approveProduct(newValue, data.item.edit)">
                        </b-form-checkbox>
                      </div>
                      <b-tooltip
                        :target="`productsApproved-${data.item.edit}`"
                        triggers="hover"
                        v-if="data.item.approved && data.item.approvedBy"
                      >
                        {{
                          `Approved by ${
                            data.item.approvedBy.name
                          } on ${data.item.approvedTime
                            .toString()
                            .substring(0, 15)} at ${data.item.approvedTime
                            .toString()
                            .substring(16, 21)}`
                        }}
                      </b-tooltip>
                    </template>
                    <template v-slot:cell(billable)="data">
                      <div
                        :id="`productsBillable-${data.item.edit}`"
                        style="display: inline-block"
                      >
                        <b-form-checkbox v-model="data.item.billable" @change="(newValue) => updateProductBillable(newValue, data.item.edit)">
                        </b-form-checkbox>
                      </div>
                      <b-tooltip
                        :target="`productsBillable-${data.item.edit}`"
                        triggers="hover"
                        v-if="
                          data.item.billable && data.item.billableApprovedBy
                        "
                      >
                        {{
                          `Excluded from billing by ${
                            data.item.billableApprovedBy.name
                          } on ${data.item.billableApprovedTime
                            .toString()
                            .substring(
                              0,
                              15
                            )} at ${data.item.billableApprovedTime
                            .toString()
                            .substring(16, 21)}`
                        }}
                      </b-tooltip>
                    </template>
                    <template v-slot:cell(user)="data">
                      {{ data.item.user.name }}
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-right"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="productsCurrentPage"
                          :total-rows="productsTotalRows"
                          :per-page="productsPerPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
      <!--/col-->
      <!-- start here -->

      <!--/col-->
    </div>

    <!--/Hours and job specific rates-->

    <!-- Procurement -->
    <div class="row">
      <Procurement
        ref="procurementTable"
        @fileAdded="onFileAdded"
        :jobNum="jobNum"
        :jobCustomer="jobCustomer"
      ></Procurement>
    </div>
    <!-- /Procurement -->

    <!--Documents and Safety Forms  -->

    <div class="row">
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-12">
                <h4 class="card-title mb-4">Attached Files</h4>
                <div v-if="jobFiles.some((o) => o.selected == true)">
                  <small>Bulk operations</small>
                  <br />
                  <b-button
                    variant="primary"
                    class="btn btn-sm btn-primary col-xs-2"
                    v-b-modal.modal_emailDocuments
                    >Email</b-button
                  >
                  <b-button
                    variant="success"
                    class="btn btn-sm btn-success ml-1"
                    @click="onBulkDownloadFile()"
                  >
                    <span v-if="!this.loading">Download</span>
                    <div v-if="this.loading">
                      <span
                        class="spinner-border"
                        style="width: 0.5rem; height: 0.5rem"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span class="sr-only">Loading...</span>
                    </div>
                  </b-button>
                  <b-button
                    variant="primary"
                    class="btn btn-sm btn-danger ml-1"
                    @click="bulkDeleteFiles()"
                    >Delete</b-button
                  >

                  <b-modal
                    id="modal_emailDocuments"
                    title="Email Files"
                    title-class="font-18"
                    ok-title="Email"
                    @ok="emailFiles"
                  >
                    <div class="mt-4 mt-lg-0 mb-4">
                      <div>
                        <b-form ref="form">
                          <b-form-group
                            label="Email address"
                            label-for="input-name"
                            :invalid-feedback="invalidFeedbackFileEmail"
                            :state="
                              fileEmailAddress
                                ? fileEmailAddressInputValid
                                : null
                            "
                          >
                            <b-form-input
                              id="input-name"
                              v-model="fileEmailAddress"
                              :state="
                                fileEmailAddress
                                  ? fileEmailAddressInputValid
                                  : null
                              "
                            ></b-form-input>
                          </b-form-group>
                        </b-form>
                      </div>
                    </div>
                    <a
                      :hidden="!submitEmailErrorMessage"
                      class="badge badge-danger font-size-12 mr-1 ml-1 no-pointer float-right"
                      >Please input a valid email address</a
                    >
                  </b-modal>
                </div>
              </div>
              <div class="col-6">
                <div class="float-right">
                  <!-- <button @click="migrateDocuments()">import documents</button> -->
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :items="jobFiles"
                :fields="jobFilesFields"
                style="text-align: center"
              >
                <template v-slot:cell(selected)="data">
                  <b-form-checkbox v-model="data.item.selected">
                  </b-form-checkbox>
                </template>
                <template v-slot:cell(edit)="data">
                  <div>
                    <b-dropdown variant="primary" size="sm">
                      <template v-slot:button-content>
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                        @click="onDownloadFile(data.item.fileName)"
                      >
                        <i class="bx bx-cloud-download mr-2 tableIcons"></i>
                        Download
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          onDeleteFile(
                            data.item.fileName,
                            data.item.id,
                            data.item.fileSize
                          )
                        "
                      >
                        <i class="bx bx-trash mr-2 tableIcons"></i>
                        Delete
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </template>
                <template v-slot:cell(reviewed)="data">
                  <b-form-checkbox
                    v-model="data.item.reviewed"
                    @change="reviewDocument(data.item.reviewed, data.item.id)"
                    v-b-tooltip.hover
                    :title="getDocumentReviewDetails(data.item)"
                  >
                  </b-form-checkbox>
                </template>
                <template v-slot:cell(file)="data">
                  <div class="row text-left">
                    <div clas="col-3">
                      <div class="avatar-sm">
                        <span
                          class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                        >
                          <i class="bx bxs-file-doc"></i>
                        </span>
                      </div>
                    </div>
                    <div class="col-9">
                      <h5 class="font-size-14 mb-1">
                        <a
                          @click="onDownloadFile(data.item.fileName)"
                          href="javascript: void(0);"
                          class="text-dark"
                          >{{ formattedFileName(data.item.fileName) }}</a
                        >
                      </h5>
                      <span v-b-tooltip.hover :title="data.item.date">
                        <a
                          class="badge badge-primary font-size-11 mr-2 no-pointer"
                        >
                          Uploaded By : {{ data.item.uploadedBy.name }}
                        </a>
                      </span>
                      <br />
                      <small
                        >Size : {{ sizeInBytes(data.item.fileSize) }}</small
                      >
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row mt-3">
              <div class="col-12">
                <vue-dropzone
                  id="fileUploader"
                  ref="fileUploader"
                  :use-custom-slot="true"
                  :options="dropzoneOptions"
                  v-on:vdropzone-file-added="onFileAdded"
                >
                  <div class="dropzone-custom-content">
                    <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                    <h4>Drop files here or click to upload.</h4>
                  </div>
                </vue-dropzone>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->

      <!-- Start of new safety forms table  -->

      <!-- Safety Forms-->
      <div class="col-lg-8">
        <JobSpecificRates
          :employees="employees"
          :jobID="jobID"
          :jobNum="jobNum"
          :currentEmployees="currentEmployees"
          :products="products"
          :currentProducts="currentProducts"
        ></JobSpecificRates>
        <JobInvoiceTracking
          v-show="jobRevenueCalculations === 'invoices'"
          :jobNum="jobNum"
          :invoices="invoiceHistory"
          :jobID="jobID"
          :totalExpenses="totalExpenses"
          :totalRevenue="
            jobType === 'Time x Material' || jobType === null
              ? totalRevenue
              : Number(jobQuote)
          "
        >
        </JobInvoiceTracking>
        <RevenueChart
          v-if="timesLoaded && productsLoaded"
          :jobNum="jobNum"
          :allTimes="hoursTableData"
          :allProducts="productsTableData"
          :jobType="jobType"
          :jobQuote="jobQuote"
          :jobDate="jobDate"
          @revenueCalculated="revenueCalculated"
          @expensesCalculated="expensesCalculated"
        ></RevenueChart>
      </div>
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row justify-content-between">
              <div class="col-6">
                <h4 class="card-title">Safety Forms</h4>
              </div>
              <div class="col-6">
                <b-button
                  @click="getOrgSafetyForms"
                  variant="primary"
                  class="btn btn-label btn-primary float-right"
                  v-b-modal.modal_safetyFormSelection
                  ><i class="bx bx-plus label-icon"></i>Submit Safety Form
                </b-button>
                <!-- choose safety form modal -->
                <b-modal
                  id="modal_safetyFormSelection"
                  title="Select a Safety Form"
                  ref="safetyFormModal"
                  scrollable
                  centered
                  hide-footer
                >
                  <div
                    class="row justify-content-center"
                    v-if="safetyFormModalLoading"
                  >
                    <SpringSpinner
                      class="label-spinner mr-2"
                      :size="45"
                      color="#556ee6"
                    />
                  </div>
                  <div v-else-if="!safetyFormModalLoading" class="row">
                    <div
                      class="card safety-form-card col-lg-12"
                      v-for="form in allOrgSafetyForms"
                      :key="form.docId"
                      v-b-modal.modal-safetyForm
                      @click="handleSafetyFormSelection(form)"
                    >
                      <div class="card-body row">
                        <div class="col-lg-11">
                          <h5 class="mt-0 mb-4">{{ form.displayName }}</h5>
                          <p class="card-text">{{ form.description }}</p>
                        </div>
                        <div class="col-lg-1 d-flex align-items-center">
                          <i class="bx bx-right-arrow-alt h1"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-modal>
                <!-- choose safety form modal end -->
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptionsSafety"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="safetyFormTableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPageSafety"
                :sort-by.sync="sortBySafety"
                :sort-desc.sync="sortDescSafety"
                :sort-compare="tableSort"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template v-slot:cell(view)="data">
                  <b-button
                    variant="primary"
                    v-b-modal.modal_addSafetyForm
                    @click="
                      viewCompletedForm(
                        data.item.View,
                        data.item.Form,
                        data.item.Date,
                        data.item.Employee,
                        data.item.AssociatedFormID
                      )
                    "
                    ><i class="bx bx-info-circle mr-2 tableIcons"></i
                    >View</b-button
                  >
                </template>
                <template v-slot:cell(jobNum)="data">
                  <v-select
                    :options="allOrgJobs"
                    label="jobNum"
                    :reduce="job => job.jobNum"
                    :filter="fuseSearch"
                    v-model="data.item.jobNum"
                    @input="(input) => updateJobNumForSubmittedForm(input, data.item.View)"
                    >
                    <template v-slot:option="option">
                      <ul class="text-wrap pl-1">
                        <li class="font-weight-bold border-top">{{ option.jobNum }}</li>
                        <li>{{ option.customer }}</li>
                        <li class="">{{ option.description }}</li>
                      </ul>
                    </template>
                  </v-select>
                </template>
                <template v-slot:cell(pdf)="data">
                  <b-button
                  variant="primary"
                  @click="genSafetyFormPDF(
                      data.item.View,
                      data.item.Form,
                      data.item.Date,
                      data.item.Employee,
                      data.item.AssociatedFormID,
                      data.item.jobNum ? data.item.jobNum : null
                    )
                  "
                  ><i class="bx bxs-file-pdf mr-2 tableIcons" style="font-size: 1rem;"></i
                  >PDF</b-button>
                </template>
                <template v-slot:cell(date)="data">
                  {{ momentInstance(data.item.Date).format('lll') }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPageSafety"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- /Safety Forms -->

      <!-- View Safety Form-->
      <b-modal
        id="modal_addSafetyForm"
        title="Safety Form Detail"
        title-class="font-18"
        hide-footer
      >
        <div
          v-if="safetyFormDetail.signOffs.length >= 1"
          class="mt-4 mt-lg-0 mb-4"
          v-on:click="showSignOffs()"
        >
          <a
            href="javascript: void(0);"
            class="badge badge-warning font-size-14"
          >
            View Sign-Offs
          </a>
        </div>
        <div v-if="hideSignOffs == false" class="mt-4 mt-lg-0 mb-4">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Employee</th>
                <th>Date/Time</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(signOff, index) in safetyFormDetail.signOffs"
                :key="index"
              >
                <td>
                  {{ signOff.name }}
                </td>
                <td>
                  {{ signOff.date.seconds ? momentInstance(signOff.date.toDate()).format('lll') :  momentInstance(signOff.date).format('lll')}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="safety-form-view">
          <h5>Submission Info</h5>
          <div class="mt-4 mt-lg-0 mb-4">
            <strong>Document Name: </strong>{{ safetyFormDetail.name }}
          </div>
          <div class="mt-4 mt-lg-0 mb-4">
            <strong>Date Submitted: </strong>{{ momentInstance(safetyFormDetail.date).format('lll') }}
          </div>
          <div class="mt-4 mt-lg-0 mb-4">
            <strong>Submitted By: </strong>{{ safetyFormDetail.submittedBy }}
          </div>
          <div
            class="mt-4 mt-lg-0 mb-4 safety-form-view-details"
            v-for="(field, index) in safetyFormDetail.fields"
            :key="index"
          >
            <div v-if="field.type !== 'label'">
              <strong>{{ field.label }}: </strong> {{ field.value }}
            </div>
            <div v-else>
              <h5>
                {{ field.label }}
              </h5>
            </div>
          </div>
        </div>
        <div
          v-if="safetyFormDetail.revisions.length >= 1"
          class="mt-4 mt-lg-0 mb-4"
          v-on:click="showRevisionSelection()"
        >
          <a
            href="javascript: void(0);"
            class="badge badge-primary font-size-12"
          >
            View Revisions
          </a>
        </div>
        <div class="mt-4 mt-lg-0 mb-4" v-if="hideRevisionSelection == false">
          <ul class="verti-timeline list-unstyled">
            <li
              class="event-list"
              v-for="(revision, revisionIndex) in safetyFormDetail.revisions"
              :key="revisionIndex"
              @click="showRevisionDetail(revisionIndex)"
            >
              <div class="event-timeline-dot">
                <i class="bx bx-right-arrow-circle font-size-18"></i>
              </div>
              <div class="media">
                <div class="mr-3">
                  <h5 class="font-size-14">
                    {{ revision.date.seconds ? momentInstance(revision.date.toDate()).format('lll') :  momentInstance(revision.date).format('lll')}}
                    <i
                      class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                    ></i>
                  </h5>
                </div>
                <div class="media-body">
                  <div>{{ revisionIndex === 0 ? revision.employee : safetyFormDetail.revisions[revisionIndex - 1].employee }}</div>
                </div>
              </div>
              <div v-show="revision.shown">
                <div
                  class="mt-4 mt-lg-0 mb-4"
                  v-for="(field, fieldIndex) in safetyFormDetail.fields"
                  :key="fieldIndex"
                >
                  <strong>{{ field.label }}: </strong>
                  {{ revision[field.name.toLowerCase()] }}
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div>
          <div class="col-12">
            <div class="row justify-content-end mt-5 mb-2">
                <EditSafetyForm :formData="safetyFormDetail" :viewFormLoaded="viewFormLoaded" @update-safety-form-data="updateSafetyFormData"/>
                <b-button class="mr-2" :disabled="!currentUser.position.includes('Admin')" v-b-tooltip :title="!currentUser.position.includes('Admin') ? 'Only Admin level users can sign off.' : ''" variant="success" size="md"  @click="signOffSafetyForm()">
                  Sign-Off
                </b-button>
                <b-button size="md" @click="$bvModal.hide('modal_addSafetyForm')">
                  Close
                </b-button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <!-- /Documents and Safety Forms -->

    <!-- <div class="row">
      <div class="col-lg-12 text-center mt-3 mb-3">
        <h3>Under Development</h3>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <div class="card comingSoon">
          <div class="card-body">
            <h4 class="card-title mb-4">Billing Overview</h4>

            <div id="overview-chart" class="apex-charts" dir="ltr"></div>
            <apexchart
              class="apex-charts"
              type="bar"
              height="280"
              :series="barChart.series"
              :options="barChart.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>


      <div class="col-lg-4">
        <div class="card comingSoon">
          <div class="card-body">
            <h4 class="card-title mb-4">Comments</h4>

            <div class="media mb-4">
              <div class="mr-3">
                <img
                  class="media-object rounded-circle avatar-xs"
                  alt
                  src="@/assets/images/users/avatar-2.jpg"
                />
              </div>
              <div class="media-body">
                <h5 class="font-size-13 mb-1">David Lambert</h5>
                <p class="text-muted mb-1">Separate existence is a myth.</p>
              </div>
              <div class="ml-3">
                <a href class="text-primary">Reply</a>
              </div>
            </div>

            <div class="media mb-4">
              <div class="mr-3">
                <img
                  class="media-object rounded-circle avatar-xs"
                  alt
                  src="@/assets/images/users/avatar-3.jpg"
                />
              </div>
              <div class="media-body">
                <h5 class="font-size-13 mb-1">Steve Foster</h5>
                <p class="text-muted mb-1">
                  <a href class="text-success">@Henry</a>
                  To an English person it will like simplified
                </p>
                <div class="media mt-3">
                  <div class="avatar-xs mr-3">
                    <span
                      class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                      >J</span
                    >
                  </div>
                  <div class="media-body">
                    <h5 class="font-size-13 mb-1">Jeffrey Walker</h5>
                    <p class="text-muted mb-1">
                      as a skeptical Cambridge friend
                    </p>
                  </div>
                  <div class="ml-3">
                    <a href class="text-primary">Reply</a>
                  </div>
                </div>
              </div>
              <div class="ml-3">
                <a href class="text-primary">Reply</a>
              </div>
            </div>

            <div class="media mb-4">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                  >S</span
                >
              </div>
              <div class="media-body">
                <h5 class="font-size-13 mb-1">Steven Carlson</h5>
                <p class="text-muted mb-1">Separate existence is a myth.</p>
              </div>
              <div class="ml-3">
                <a href class="text-primary">Reply</a>
              </div>
              <div class="ml-3">
                <a href class="text-primary">Reply</a>
              </div>
            </div>

            <div class="text-center mt-4 pt-2">
              <a href="javascript: void(0);" class="btn btn-primary btn-sm"
                >View more</a
              >
            </div>

            <div class="text-center mt-4 pt-2">
              <a href="javascript: void(0);" class="btn btn-primary btn-sm"
                >View more</a
              >
            </div>
          </div>
        </div>
      </div>

    </div> -->
    <!-- end row -->
    <!-- safety form modal -->
    <b-modal
      id="modal-safetyForm"
      class="safety-form-modal"
      scrollable
      centered
      ok-title="Submit"
      @show="handleSafetyFormModalShow"
      @hidden="handleSafetyFormModalHide"
      @ok="handleSafetyFormModalSubmit"
    >
      <div slot="modal-header">
        <h4>{{ selectedForm.displayName }}</h4>
        <p>{{ selectedForm.description }}</p>
      </div>
      <div v-for="input in selectedForm.inputs" :key="input.edit">
        <div class="text-right">
          <div
            class="row mb-3"
            v-if="
              input.type === 'checkbox' ||
              input.type === 'textarea' ||
              input.type === 'number'
            "
          >
            <label class="col-6 my-auto">
              <span
                v-if="input.required && input.type !== 'checkbox'"
                class="text-danger"
                >*</span
              >
              {{ input.label }}
            </label>
            <b-checkbox
              v-if="input.type === 'checkbox'"
              :type="input.type"
              :id="input.name.replace(/\s+/g, '')"
              v-model="input.value"
            />
            <b-textarea
              class="col-5"
              v-else-if="input.type === 'textarea'"
              :type="input.type"
              :id="input.name.replace(/\s+/g, '')"
              v-model="input.value"
            />
            <b-form-input
              class="col-2"
              :id="input.name.replace(/\s+/g, '')"
              v-else-if="input.type === 'number'"
              :type="input.type"
              v-model="input.value"
            />
          </div>
          <div class="row mb-3 text-center" v-else-if="input.type === 'label'">
            <h5 class="col-12">{{ input.label }}</h5>
          </div>
          <div class="row mb-4" v-else-if="input.type === 'dropdown'">
            <label class="col-6 my-auto">
              <span
                v-if="input.required && input.type !== 'checkbox'"
                class="text-danger"
                >*</span
              >
              {{ input.label }}
            </label>
            <b-form-select
              v-if="input.collectionData !== undefined"
              class="col-5"
              :id="input.name.replace(/\s+/g, '')"
              :options="input.collectionData.values"
              v-model="input.value"
              full-width
            ></b-form-select>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- safety form modal end -->
  </Layout>
</template>

<script>
import Vue from 'vue';
import Layout from '../../../layouts/main';
import PageHeader from '@/components/page-header';
import appConfig from '@/app.config';
import routes from '../../../routes.js';
import DatePicker from 'vue2-datepicker';
import Swal from 'sweetalert2';
import dynamicControls from '../components/dynamicControls.vue';
import vue2Dropzone from 'vue2-dropzone';
import JobSpecificRates from '../components/jobs/JobSpecificRates.vue';
import JobInvoiceTracking from '../components/jobs/JobInvoiceTracking.vue';
import RevenueChart from '../components/jobs/RevenueChart.vue';
import Procurement from '../components/jobs/Procurement.vue';
import Switches from 'vue-switches';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);
import axios from 'axios';
import JobBudgets from '../components/jobs/JobBudgets.vue';
import firebase from 'firebase';
import { firestore } from 'firebase';
import moment from 'moment';
import JSZip from 'jszip';
import saveAs from 'file-saver';
import { SpringSpinner } from 'epic-spinners';
import { cssEscape } from '../helper/helpers'
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import lodash from 'lodash';

import {
  getSafetyForms,
  getEmployees,
  getEmployeesRate,
  getCustomers,
  getFieldTicketForm,
  getProductForm,
  getSafetyFormFields,
  getInvoiceTemplate,
  getCustomCollectionDataFromName,
  getSpecificJobs,
  validateEmail,
  getJobs
} from '../helper/dbHelpers.js';
import {
  getFilesForJob,
  uploadFile,
  downloadFile,
  deleteFile,
} from '../helper/storageHelpers.js';
// import { updateStorageBilling } from '../helper/billingHelpers.js';
import { tableSort, bytesToSize } from '../helper/helpers.js';
import {generateSafetyFormPDF} from '../components/safety/generateSafetyFormPDF.js';
import EditSafetyForm from '../components/safety/EditSafetyForm.vue';
import Fuse from 'fuse.js'

export default {
  page: {
    title: 'jobDetails',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    dynamicControls,
    vueDropzone: vue2Dropzone,
    JobSpecificRates,
    Procurement,
    Switches,
    RevenueChart,
    JobBudgets,
    JobInvoiceTracking,
    SpringSpinner,
    EditSafetyForm
  },
  data() {
    0;
    return {
      title: 'Job Details ',
      name: 'jobDetails',
      items: [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'search jobs',
          href: '/production/jobs/searchJobs',
        },
        {
          text: 'job details',
          href: '/production/jobs/jobDetails',
          active: true,
        },
      ],
      routes: routes,
      jobNum: null,
      jobCustomer: null,
      supervisor: null,
      jobDepartment: null,
      jobType: null,
      jobQuote: null,
      jobDate: null,
      jobDesc: null,
      jobID: null,
      jobRevenueCalculations: null,
      controls: null,
      approvedStatus: { times: 0, products: 0, files: 0 },
      procurementControls: null,
      controlsEnabled: null,
      editedControlsEnabled: null,
      max: 1000000000,
      editedControls: {
        labour: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Billable Rate',
          value: null,
          name: 'Labour',
          types: ['Dollar Amount'],
          unitOfMeasures: ['Billable Rate', 'Payroll Rate'],
        },
        products: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Billable Rate',
          value: null,
          name: 'Products',
          types: ['Dollar Amount'],
          unitOfMeasures: ['Billable Rate'],
        },
        procurements: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Marked-up Amount',
          value: null,
          name: 'Procurements',
          types: ['Dollar Amount'],
          unitOfMeasures: ['Marked-up Amount', 'Received Amount'],
        },
      },
      editedProcurementControls: {
        thirdParty: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Marked-up Amount',
          value: null,
          name: '3rd Party',
          types: ['Dollar Amount'],
          unitOfMeasures: ['Marked-up Amount', 'Received Amount'],
        },
        consumables: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Marked-up Amount',
          value: null,
          name: 'Consumables',
          types: ['Dollar Amount'],
          unitOfMeasures: ['Marked-up Amount', 'Received Amount'],
        },
        materials: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Marked-up Amount',
          value: null,
          name: 'Materials',
          types: ['Dollar Amount'],
          unitOfMeasures: ['Marked-up Amount', 'Received Amount'],
        },
        other: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Marked-up Amount',
          value: null,
          name: 'Other',
          types: ['Dollar Amount'],
          unitOfMeasures: ['Marked-up Amount', 'Received Amount'],
        },
        rentals: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Marked-up Amount',
          value: null,
          name: 'Rentals',
          types: ['Dollar Amount'],
          unitOfMeasures: ['Marked-up Amount', 'Received Amount'],
        },
      },
      originalControls: {
        labour: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Billable Rate',
          value: null,
          name: 'Labour',
        },
        products: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Billable Rate',
          value: null,
          name: 'Products',
        },
        procurements: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Marked-up Amount',
          value: null,
          name: 'Procurements',
        },
      },
      originalProcurementControls: {
        thirdParty: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Marked-up Amount',
          value: null,
          name: '3rd Party',
        },
        consumables: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Marked-up Amount',
          value: null,
          name: 'Consumables',
        },
        materials: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Marked-up Amount',
          value: null,
          name: 'Materials',
        },
        other: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Marked-up Amount',
          value: null,
          name: 'Other',
        },
        rentals: {
          active: false,
          type: 'Dollar Amount',
          unitOfMeasure: 'Marked-up Amount',
          value: null,
          name: 'Rentals',
        },
      },
      editJob_selectedCustomer: null,
      editJob_date: null,
      editJob_desc: null,
      editJob_supervisor: null,
      editJob_jobDepartment: null,
      editJob_jobType: null,
      editJob_jobQuote: null,
      editJob_selectedRevenueType: 'default',
      editJob_errors: {
        customerError: false,
        customerMessage: null,
        dateError: false,
        dateMessage: null,
        descError: false,
        descMessage: null,
      },
      hoursTotalRows: 1,
      hoursCurrentPage: 1,
      hoursPerPage: 10,
      hoursPageOptions: [10, 25, 50, 100],
      hoursFilter: null,
      hoursFilterOn: [],
      hoursSortBy: 'date',
      hoursSortDesc: true,
      products: [],
      productsTotalRows: 1,
      productsCurrentPage: 1,
      productsPerPage: 10,
      productsPageOptions: [10, 25, 50, 100],
      productsFilter: null,
      productsFilterOn: [],
      productsSortBy: 'date',
      productsSortDesc: true,
      employees: [],
      customers: [],
      jobTypeOptions: ['Quoted (Fixed Rate)', 'Time x Material'],
      addTimeModal: false,
      editTime_selectedEmployee: null,
      editTime_date: null,
      editTime_hours: null,
      editTime_desc: null,
      editTime_id: null,
      editTime_index: null,
      editTimeDynamic: null,
      editTime_errors: {
        employeeError: false,
        employeeMessage: null,
        dateError: false,
        dateMessage: null,
        hoursError: false,
        hoursMessage: null,
        descError: false,
        descMessage: null,
      },
      editTime_rate: null,
      editTime_overtimeRate: null,
      moveTimeObj: { id: '', employee: '', date: '', description: '' },
      editProduct_selectedEmployee: null,
      editProduct_date: null,
      editProduct_hours: null,
      editProduct_desc: null,
      editProduct_id: null,
      editProduct_index: null,
      editProduct_errors: {
        dateError: false,
        dateMessage: null,
        quantityError: false,
        quantityMessage: null,
        productsError: false,
        productsMessage: null,
      },
      createInvoice_startDate: null,
      createInvoice_endDate: null,
      createInvoice_errors: {
        startDateError: false,
        startDateMessage: null,
        endDateError: false,
        endDateMessage: null,
      },
      currentEmployees: [],
      currentProducts: [],
      productOptions: [],
      hoursFields: [],
      hoursTableData: [],
      productsFields: [],
      productsTableData: [],
      barChart: {
        series: [
          {
            name: 'Overview',
            data: [42, 56, 40, 64, 26, 42, 56, 35, 62],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              columnWidth: '14%',
              endingShape: 'rounded',
            },
          },
          dataLabels: {
            enabled: false,
          },
          grid: {
            yaxis: {
              lines: {
                show: false,
              },
            },
          },
          yaxis: {
            title: {
              text: 'Hours Worked',
            },
          },
          xaxis: {
            labels: {
              rotate: -90,
            },
            categories: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
            title: {
              text: 'Week',
            },
          },
          colors: ['#556ee6'],
        },
      },
      editTimeHourType: 'regular',
      editTimeTravel: false,
      fieldTicketFormEdit: [],
      fieldTicketForm: [],
      fieldTicketFormInitial: [],
      productForm: [],
      jobFiles: [],
      jobFilesFields: [
        { key: 'Selected', label: '', sortable: false },
        { key: 'Edit', sortable: false },
        { key: 'Reviewed', sortable: true },
        { key: 'File', label: 'File', sortable: true },
      ],
      dropzoneOptions: {
        url: '/',
        addRemoveLinks: true,
        method: 'put',
        chunking: true,
        forceChunking: true,
        autoQueue: false,
        autoProcessQueue: false,
        thumbnailWidth: 50,
        maxFilesize: 250,
      },
      fields: [
        { key: 'View', sortable: false, thStyle: 'width: 120px;' },
        { key: 'jobNum', label: 'Job', sortable: true, thStyle: 'width: 250px;' },
        { key: 'PDF', sortable: false },
        { key: 'Date', sortable: true },
        { key: 'Form', sortable: true },
        { key: 'Employee', sortable: true },
        { key: 'AssociatedFormID', visible: false },
      ],
      allOrgSafetyForms: null,
      safetyFormModalLoading: true,
      safetyForms: [],
      safetyFormTableData: [],
      safetyFormDetail: {
        name: null,
        date: null,
        submittedBy: null,
        fields: [],
        signOffs: [],
        revisions: [],
        formID: null
      },
      selectedForm: {},
      perPage: 10,
      pageOptionsSafety: [5, 10, 25, 50, 100],
      orgJobs: [],
      sortBySafety: 'date',
      sortDescSafety: false,
      filter: null,
      filterOn: [],
      currentPageSafety: 1,
      hideSignOffs: true,
      hideRevisionSelection: true,
      selectedDocuments: [],
      fileEmailAddress: null,
      fileEmailAddressInputValid: false,
      submitEmailErrorMessage: false,
      timesLoaded: false,
      timeTransitionJob: null,
      productsLoaded: false,
      showBudgets: false,
      revenueSummary: null,
      expensesSummary: null,
      totalExpenses: null,
      totalRevenue: null,
      jobBudget: null,
      jobBudgetEditComplete: true,
      employeeOptions: [],
      hoursOptions: ['overtime', 'travel', 'regular'],
      jobComplete: false,
      budgetRevisions: [],
      showBudgetRevisions: false,
      jobDetailsLoaded: false,
      companySettings: {},
      invoiceHistory: [],
      revenueTypes: [
        { label: 'Default', value: 'default' },
        { label: 'Invoiced Amount', value: 'invoices' },
      ],
      loading: false,
      currentUser: this.$store.state.custom.currentUserData,
      momentInstance: moment,
      viewFormLoaded: false,
      futureTimesEnabled: false,
      editJob_futureTimesEnabled: false,
      allOrgJobs: [],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.safetyFormTableData.length;
    },
    //validator for the email address in the file bulk email.
    invalidFeedbackFileEmail() {
      if (
        this.fileEmailAddress === null ||
        this.fileEmailAddress === undefined ||
        this.fileEmailAddress.trim() === ''
      ) {
        this.changeValidationValue('fileEmailAddress', false);
        return 'Please enter a valid email address';
      } else if (validateEmail(this.fileEmailAddress)) {
        this.changeValidationValue('fileEmailAddress', true);
      } else {
        this.changeValidationValue('fileEmailAddress', false);
        return 'Please enter a valid email address';
      }
      return 'Please enter a valid email address';
    },
  },
  watch: {
    perPage(newVal, oldVal) {
      // safety forms table length setting
      if (newVal !== oldVal) {
        this.currentUser = this.$store.state.custom.currentUserData;
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        let oldCurrentUserPerPage = null;

        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_jobDetsSafetyForms){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_jobDetsSafetyForms;
          }
          currentUserDataCopy.tablePageLengths['perPage_jobDetsSafetyForms'] =
            newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_jobDetsSafetyForms: newVal,
          };
        }

        // prevent a write after page render, only write to db when user manually changes page length setting
        if (
          oldCurrentUserPerPage !== newVal
        ) {
          firebase
            .firestore()
            .collection('employees')
            .doc(this.currentUser.auth)
            .update({
              tablePageLengths: currentUserDataCopy.tablePageLengths,
            });
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
    hoursPerPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentUser = this.$store.state.custom.currentUserData;
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        let oldCurrentUserPerPage = null;

        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_jobDetsHours){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_jobDetsHours;
          }
          currentUserDataCopy.tablePageLengths['perPage_jobDetsHours'] = newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_jobDetsHours: newVal,
          };
        }

        // prevent a write after page render, only write to db when user manually changes page length setting
        if (oldCurrentUserPerPage !== newVal) {
          firebase
            .firestore()
            .collection('employees')
            .doc(this.currentUser.auth)
            .update({
              tablePageLengths: currentUserDataCopy.tablePageLengths,
            });
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
    productsPerPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentUser = this.$store.state.custom.currentUserData;
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        let oldCurrentUserPerPage = null;

        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_jobDetsProducts){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_jobDetsProducts;
          }
          currentUserDataCopy.tablePageLengths['perPage_jobDetsProducts'] =
            newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_jobDetsProducts: newVal,
          };
        }

        // prevent a write after page render, only write to db when user manually changes page length setting
        if (
          oldCurrentUserPerPage !== newVal
        ) {
          firebase
            .firestore()
            .collection('employees')
            .doc(this.currentUser.auth)
            .update({
              tablePageLengths: currentUserDataCopy.tablePageLengths,
            });
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
  },
  methods: {
    async updateJobNumForSubmittedForm(selectedJobNum, submittedSafetyFormDocID){
      try{
        await firebase
              .firestore()
              .collection('safetyForms')
              .doc(submittedSafetyFormDocID)
              .update({
                jobNum: selectedJobNum
              });

        // update local data
        if(selectedJobNum !== this.jobNum){
          let tableDataCopy = lodash.cloneDeep(this.safetyFormTableData);
          const index = tableDataCopy.findIndex((x) => x.View === submittedSafetyFormDocID);
          tableDataCopy.splice(index, 1);
          this.safetyFormTableData = tableDataCopy;
        }

        Vue.$toast.open({
          message: `Associated job updated successfully. Moved submitted safety form to job #${selectedJobNum}`,
          type: 'success',
          duration: 60000,
          position: 'top-right',
        });
      }catch(err){
        Vue.$toast.open({
          message: `Error updating the associated job for the submitted safety form.`,
          duration: 8000000,
          position: 'top-right',
          dismissible: true,
          type: 'error',
        });
        console.log('Error updating the associated job for the submitted safety form.: ', err);
      }
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['jobNum', 'customer', 'description'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
    updateSafetyFormData: function(editedSafetyFormData){
      this.safetyFormDetail = editedSafetyFormData;
      const index = this.safetyFormTableData.findIndex((x) => x.View === editedSafetyFormData.formID);
      let tableDataCopy = lodash.cloneDeep(this.safetyFormTableData);
      tableDataCopy[index].Date = editedSafetyFormData.date;
      tableDataCopy[index].revisions = editedSafetyFormData.revisions;

      this.safetyFormTableData = tableDataCopy;
    },
    signOffSafetyForm: function () {
      // add sign-off details object to the forms "sign-offs" array
      let signOffDetails = {
        date: new Date(),
        id: this.currentUser.auth,
        name: this.currentUser.name
      }

      let tableDataCopy = lodash.cloneDeep(this.safetyFormTableData);
      const formIndex = tableDataCopy.findIndex((x) => x.View === this.safetyFormDetail.formID);
      if(!tableDataCopy[formIndex]['sign-offs']){
        tableDataCopy[formIndex]['sign-offs'] = [signOffDetails];
      } else{
        tableDataCopy[formIndex]['sign-offs'].push(signOffDetails);
      }

      try {
        firebase
          .firestore()
          .collection('safetyForms')
          .doc(this.safetyFormDetail.formID)
          .update({
            'sign-offs': tableDataCopy[formIndex]['sign-offs'],
          }).then(() => {
            this.safetyFormTableData = tableDataCopy;
            this.safetyFormDetail.signOffs.push(signOffDetails);
            Vue.$toast.open({
              message: 'Sign-off submitted successfully.',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          });
      } catch (err) {
        Vue.$toast.open({
          message: `Error updating the sign-offs for the safety form.`,
          duration: 8000000,
          position: 'top-right',
          dismissible: true,
          type: 'error',
        });
        console.log('Error updating the safety form sign-offs in the db: ', err);
      }
    },
    genSafetyFormPDF: async function (id, name, date, employee, associatedFormID, jobNum) {
      await this.viewCompletedForm(id, name, date, employee, associatedFormID, jobNum);
      try {
        const docDefinition = generateSafetyFormPDF(this.safetyFormDetail);

        pdfMake.createPdf(docDefinition).download('Safety Form Submission Details.pdf');
      } catch (err) {
        Vue.$toast.open({
          message: `Error generating the PDF file for the safety form.`,
          duration: 8000000,
          position: 'top-right',
          dismissible: true,
          type: 'error',
        });
        console.log(err);
      }
    },
    viewCompletedForm: async function (id, name, date, employee, associatedFormID, jobNum) {
      // reset loading bool
      this.viewFormLoaded = false
      // return a new promise, we do this so we can await it properly in the genSafetyFormPDF function
      return new Promise((resolve, reject) => {
        //reset the sign-offs flag, so they aren't default showing.
        this.hideSignOffs = true;
        this.hideRevisionSelection = true;
        //reset the form detail modal.
        this.safetyFormDetail = {
          name: null,
          date: null,
          submittedBy: null,
          fields: [],
          signOffs: [],
          revisions: [],
          formID: null,
          jobNum: jobNum
        };

        //get the completed form's info and populate the modal.
        getSafetyFormFields(associatedFormID)
          .then((response) => {
            let inputs = response.data().inputs;
            for (let i = 0; i <= inputs.length - 1; i++) {
              this.safetyFormDetail.fields.push({
                type: inputs[i].type,
                label: inputs[i].label,
                name: inputs[i].name.replace(/\s+/g, ''),
                value: null,
                required: inputs[i].required,
                collection: inputs[i].collection ? inputs[i].collection : null
              });
            }

            this.safetyFormDetail.displayName = response.data().displayName;
            this.safetyFormDetail.description = response.data().description;
          })
          .then(() => {
            firebase
              .firestore()
              .collection('safetyForms')
              .doc(id)
              .get()
              .then(async (doc) => {
                this.safetyFormDetail.name = name;
                this.safetyFormDetail.date = date;
                this.safetyFormDetail.submittedBy = employee;
                this.safetyFormDetail.formID = doc.id;
                this.safetyFormDetail.signOffs = doc.data()['sign-offs'] ? doc.data()['sign-offs'] : [];
                this.safetyFormDetail.revisions = doc.data().revisions ? doc.data().revisions : [];
                this.safetyFormDetail.associatedFormID = doc.data().associatedFormID;
                this.safetyFormDetail.employee = doc.data().employee;

                //loop the inputs and get the values.
                for (const [index, field] of this.safetyFormDetail.fields.entries()) {
                  field.value = doc.data()[field.name.toLowerCase()];

                  if (field.type === 'dropdown') {
                    // if the form contains a dropdown input then retrieve it's associated collection and add it to the specific input object
                    const snapshot = await firebase
                      .firestore()
                      .collection('customCollections')
                      .where('name', '==', field.collection)
                      .where('org', '==', sessionStorage.getItem('org'))
                      .get();

                    if (!snapshot.empty) {
                      let modifiedDocData = snapshot.docs[0].data();
                      modifiedDocData['docId'] = snapshot.docs[0].id;

                      this.$set(
                        this.safetyFormDetail.fields[index],
                        'collectionData',
                        modifiedDocData
                      );
                    } else {
                      Swal.fire(
                        'Error!',
                        `Error getting custom collection data`,
                        'error'
                      );
                      reject();
                    }
                  }
                }

                resolve();
                this.viewFormLoaded = true;
              })
              .catch((err) => {
                Swal.fire(
                  'Error!',
                  `Error getting safety form data: ${err}`,
                  'error'
                );
                reject();
              });
          })
          .catch((err) => {
            Swal.fire(
              'Error!',
              `Error getting safety form data: ${err}`,
              'error'
            );
            reject();
          });
      })
    },
    generateSafetyFormTable: function () {
      try {
        firebase
          .firestore()
          .collection('safetyForms')
          .where('org', '==', sessionStorage.getItem('org'))
          .where('jobNum', '==', this.jobNum)
          .orderBy('dateSubmitted', 'desc')
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.empty) {
              console.log('No records returned.');
            }

            querySnapshot.forEach((doc) => {
              if(this.safetyForms.find((o) => o.id == doc.data().associatedFormID)){
                  let newForm = {
                  View: doc.id,
                  Date: moment(doc.data().dateSubmitted.toDate()).format(
                    'MMM DD, YY HH:mm'
                  ),
                  Form: this.safetyForms.find(
                    (o) => o.id == doc.data().associatedFormID
                  ) ? this.safetyForms.find(
                    (o) => o.id == doc.data().associatedFormID
                  ).name : 'N/A',
                  Employee: doc.data().employee,
                  AssociatedFormID: doc.data().associatedFormID,
                  'sign-offs': doc.data()['sign-offs'] ? doc.data()['sign-offs'] : [],
                  revisions: doc.data().revisions ? doc.data().revisions : [],
                  jobNum: doc.data().jobNum ? doc.data().jobNum : null,
                };

                this.safetyFormTableData.push(newForm);
              }
            });
          })
          .catch((err) => {
            console.log('Error getting safety docs: ', err);
          });
      } catch (err) {
        console.log(`Error getting job data: ${err}`);
      }
    },
    getOrgSafetyForms: async function () {
      this.safetyFormModalLoading = true;

      // get all safety forms to display for the current user's organization if they have not been retrieved yet
      if (this.allOrgSafetyForms === null) {
        try {
          firebase
            .firestore()
            .collection('organizations')
            .doc(sessionStorage.getItem('org'))
            .collection('safetyForms')
            .orderBy('displayName', 'asc')
            .get()
            .then((snapshot) => {
              let safetyFormDocs = [];
              snapshot.docs.map((doc) => {
                if(!doc.data().dateDeactivated){
                  let modifiedDocData = doc.data();
                  modifiedDocData['docId'] = doc.id;
                  safetyFormDocs.push(modifiedDocData);
                }
              });
              this.allOrgSafetyForms = safetyFormDocs;
              this.safetyFormModalLoading = false;
            });
        } catch (err) {
          Swal.fire(
            'Error!',
            'An error occurred while trying to retrieve the safety forms for your organization.',
            'error'
          );
          console.log(err);
        }
      } else {
        this.safetyFormModalLoading = false;
      }
    },
    handleSafetyFormSelection: function (form) {
      this.selectedForm = form;
      this.$refs['safetyFormModal'].hide();
    },
    handleSafetyFormModalShow: function () {
      // if the form contains a dropdown input then retrieve it's associated collection and add it to the specific input object
      this.selectedForm.inputs.map((input) => {
        if (input.type === 'dropdown') {
          // query for collection data
          firebase
            .firestore()
            .collection('customCollections')
            .where('name', '==', input.collection)
            .where('org', '==', sessionStorage.getItem('org'))
            .get()
            .then((snapshot) => {
              snapshot.docs.map((doc) => {
                let modifiedDocData = doc.data();
                modifiedDocData['docId'] = doc.id;

                // find index of this specific input
                let index = this.selectedForm.inputs.findIndex(
                  (x) => x.edit === input.edit
                );
                this.$set(
                  this.selectedForm.inputs[index],
                  'collectionData',
                  modifiedDocData
                );
              });
            });
        }
      });
    },
    handleSafetyFormModalHide: function () {
      // reset modal values
      this.selectedForm.inputs.map((input) => {
        input.value = null;
      });
    },
    handleSafetyFormModalSubmit: function (bvModalEvt) {
      let safetyForm = {};
      let valid = true;

      // validate form inputs
      this.selectedForm.inputs.map((input) => {
        // remove spaces from name
        let name = input.name.replace(/\s+/g, '');
        let element = document.querySelector(`#${cssEscape(name)}`);

        if (
          (input.value === undefined ||
            input.value === null ||
            (input.type !== 'checkbox' ? input.value.trim() === '' : '')) &&
          input.required &&
          input.type !== 'label' &&
          input.type !== 'checkbox'
        ) {
          // add error class to specific input component
          if (element !== null) {
            element.classList.add('is-invalid');
          }
          valid = false;
        } else {
          // remove error class / add the name/value pair to form object / add null if no value exists
          if (input.type !== 'label') {
            if (element !== null) {
              element.classList.remove('is-invalid', 'ddl-is-invalid');
            }
            if (input.value === undefined || input.value === null) {
              if (input.type === 'checkbox') {
                // if a checkbox is left untouched when submitted then we need to set its value to false instead of null
                safetyForm[name.toLowerCase()] = false;
              } else {
                safetyForm[name.toLowerCase()] = null;
              }
            } else {
              safetyForm[name.toLowerCase()] = input.value;
            }
          }
        }
      });

      if (valid) {
        safetyForm['associatedFormID'] = this.selectedForm.docId;
        safetyForm['dateSubmitted'] = new Date();
        safetyForm['org'] = sessionStorage.getItem('org');
        safetyForm['employee'] = JSON.parse(
          sessionStorage.getItem('authUser')
        ).displayName;
        safetyForm['user'] = firebase.auth().currentUser.uid;
        safetyForm['jobNum'] = this.jobNum;
        // write a new safety form to db
        try {
          firebase
            .firestore()
            .collection('safetyForms')
            .add(safetyForm)
            .then((res) => {
              // add the new safety form into the jobs safety forms table
              let newTableObject = {};
              newTableObject['AssociatedFormID'] = safetyForm.associatedFormID;
              newTableObject['Date'] = moment(safetyForm.dateSubmitted).format(
                'MMM DD, YY HH:mm'
              );
              newTableObject['Employee'] = safetyForm.employee;
              newTableObject['Form'] = this.selectedForm.displayName;
              newTableObject['View'] = res.id;
              newTableObject['jobNum'] = this.jobNum;

              let tableDataCopy = JSON.parse(
                JSON.stringify(this.safetyFormTableData)
              );
              tableDataCopy.unshift(newTableObject);
              this.safetyFormTableData = tableDataCopy;

              Swal.fire(
                'Success!',
                `Safety form submitted for job #${this.jobNum}.`,
                'success'
              );
            })
            .catch((err) => {
              Swal.fire(
                'Error!',
                'An error occurred while trying to submit the safety form to the database.',
                'error'
              );
              console.log('Error submitting safety form to database: ', err);
            });
        } catch (err) {
          Swal.fire(
            'Error!',
            'An error occurred while trying to submit the safety form.',
            'error'
          );
          console.log('Error submitting safety form to database: ', err);
        }
      } else {
        bvModalEvt.preventDefault();
      }
    },
    addTime: function (bvModalEvt) {
      if (
        this.companySettings.mobileOvertimeField ||
        this.companySettings.mobileTravelTimeField
      ) {
        try {
          let updatedTableData = [];
          let promises = [];
          let allForms = [];

          //create the form object that we can validate and insert.
          let validatedForm = this.validateAddTime();
          if (validatedForm) {
            validatedForm.jobNum = this.jobNum;
            validatedForm.customer = this.jobCustomer.toLowerCase();

            validatedForm.org = sessionStorage.getItem('org');
            validatedForm.user = this.editTime_selectedEmployee.uid;
            validatedForm.employee = this.editTime_selectedEmployee.name;

            //set the time to noon of the timezone that it is added in to avoid the day changing
            validatedForm.date = new Date(
              moment(validatedForm.date).add(12, 'hours')
            );

            validatedForm.travelTime = validatedForm.traveltime;
            delete validatedForm['traveltime'];

            if (
              validatedForm.overtime !== undefined &&
              validatedForm.overtime !== null &&
              validatedForm.overtime.trim() !== ''
            ) {
              let validatedFormOvertime = JSON.parse(
                JSON.stringify(validatedForm)
              );
              validatedFormOvertime.hours = validatedFormOvertime.overtime;
              validatedFormOvertime.overtime = true;
              validatedFormOvertime.travelTime = false;
              validatedFormOvertime.date = new Date(validatedFormOvertime.date);
              validatedFormOvertime.rate =
                validatedFormOvertime['overtime rate'];
              validatedFormOvertime['approved'] = false;
              delete validatedFormOvertime['overtime rate'];
              delete validatedFormOvertime['travel rate'];

              allForms.push(validatedFormOvertime);
              promises.push(
                firestore().collection('times').add(validatedFormOvertime)
              );
            }
            if (
              validatedForm.travelTime !== undefined &&
              validatedForm.travelTime !== null &&
              validatedForm.travelTime.trim() !== ''
            ) {
              let validatedFormTravel = JSON.parse(
                JSON.stringify(validatedForm)
              );
              validatedFormTravel.hours = validatedFormTravel.travelTime;
              validatedFormTravel.overtime = false;
              validatedFormTravel.travelTime = true;
              validatedFormTravel.date = new Date(validatedFormTravel.date);
              validatedFormTravel.rate = validatedFormTravel['travel rate'];
              validatedFormTravel['approved'] = false;
              delete validatedFormTravel['overtime rate'];
              delete validatedFormTravel['travel rate'];

              allForms.push(validatedFormTravel);
              promises.push(
                firestore().collection('times').add(validatedFormTravel)
              );
            }
            if (
              validatedForm.hours !== undefined &&
              validatedForm.hours !== null &&
              validatedForm.hours.trim() !== ''
            ) {
              let validatedFormRegular = JSON.parse(
                JSON.stringify(validatedForm)
              );

              validatedFormRegular.overtime = false;
              validatedFormRegular.travelTime = false;
              validatedFormRegular.date = new Date(validatedFormRegular.date);
              validatedFormRegular['approved'] = false;
              delete validatedFormRegular['overtime rate'];
              delete validatedFormRegular['travel rate'];

              allForms.push(validatedFormRegular);
              promises.push(
                firestore().collection('times').add(validatedFormRegular)
              );
            }

            Promise.all(promises)
              .then((docs) => {
                //add the document id to the edit field  for each added document
                docs.forEach((doc, index) => {
                  allForms[index].edit = doc.id;
                });
                //populate the rest of the object with the info that is needed for the table and edit.
                allForms.forEach((form) => {
                  updatedTableData = {};
                  form.date = moment(form.date).format('MMM DD, YY');
                  form.type = form.overtime
                    ? 'ot'
                    : form.travelTime
                    ? 'tt'
                    : 'reg';
                  form.lineTotal = (
                    parseFloat(form.rate) * parseFloat(form.hours)
                  ).toFixed(2);

                  // set type so type badge can update appropiately
                  form.overtime
                    ? (form['type'] = 'ot')
                    : form.travelTime
                    ? (form['type'] = 'tt')
                    : (form['type'] = 'reg');

                  for (const field in form) {
                    if (field === 'user') {
                      updatedTableData['uid'] = form[field];
                    } else {
                      updatedTableData[field] = form[field];
                    }
                  }

                  this.hoursTableData.push(updatedTableData);
                });

                Swal.fire('Success!', 'Time added successfully.', 'success');
              })
              .catch((error) => {
                console.log(`Error adding time to job. ${error}`);
                Swal.fire(
                  'Error!',
                  'An error was encountered when inserting the time.',
                  'error'
                );
              });
          } else {
            bvModalEvt.preventDefault();
          }
        } catch (error) {
          console.log(error);
          Swal.fire(
            'Error!',
            'An error was encountered when inserting the time.',
            'error'
          );
        }
      } else {
        let updatedTableData = {};
        //bvModalEvt
        try {
          //create the form object that we can validate and insert.
          let validatedForm = this.validateAddTime();
          if (!validatedForm === false) {
            validatedForm.jobNum = this.jobNum;
            validatedForm.customer = this.jobCustomer.toLowerCase();

            validatedForm.org = sessionStorage.getItem('org');
            validatedForm.user = this.editTime_selectedEmployee.uid;
            validatedForm.employee = this.editTime_selectedEmployee.name;
            firestore()
              .collection('times')
              .add(validatedForm)
              .then((doc) => {
                //populate the rest of the object with the info that is needed for the table and edit.
                validatedForm.edit = doc.id;
                validatedForm.date = moment(validatedForm.date).format(
                  'MMM DD, YY'
                );
                validatedForm.lineTotal = (
                  parseFloat(validatedForm.rate) *
                  parseFloat(validatedForm.hours)
                ).toFixed(2);
                // validatedForm.jobCustomer = this.jobCustomer;

                for (const field in validatedForm) {
                  if (field === 'user') {
                    updatedTableData['uid'] = validatedForm[field];
                  } else {
                    updatedTableData[field] = validatedForm[field];
                  }
                }

                this.hoursTableData.push(updatedTableData);
                Swal.fire('Success!', 'Time added successfully.', 'success');
              })
              .catch(() => {
                console.log(`Error adding time to job.`);
                Swal.fire(
                  'Error!',
                  'An error was encountered when inserting the time.',
                  'error'
                );
              });
          } else {
            bvModalEvt.preventDefault();
          }
        } catch (err) {
          Swal.fire(
            'Error!',
            'An error was encountered when inserting the time.',
            'error'
          );
        }
      }
    },
    onBulkDownloadFile: async function () {
      this.loading = true;
      try {
        let jszip = new JSZip();
        const currentDate = new Date();
        // filter out .selected items
        let selectedFiles = this.jobFiles.filter((o) => o.selected);
        // loop through selectedFiles
        for (let index = 0; index < selectedFiles.length; index++) {
          let downloadURL = '';
          try {
            // get download URL for each file
            downloadURL = await downloadFile(
              selectedFiles[index].fileName,
              selectedFiles[index].jobNum
            );
          } catch {
            (err) => {
              console.log(err);
              Vue.$toast.open({
                message: 'Error downloading file URL.',
                type: 'error',
                duration: 4000,
                position: 'top-right',
              });
            };
          }
          // add file name and call to download file into the jszip object
          jszip.file(
            selectedFiles[index].fileName,
            this.downloadUrlAsPromise(downloadURL) // This gets download
          );
          // Once at last file create zip file and save/download jszip object for user
          if (index == selectedFiles.length - 1) {
            jszip.generateAsync({ type: 'blob' }).then(function (content) {
              saveAs(
                content,
                `KaliDocuments-${currentDate.toDateString()}.zip`
              );
            });
          }
        }
        this.loading = false;
      } catch {
        (err) => {
          this.loading = false;
          console.log(err);
          Vue.$toast.open({
            message: 'Error downloading .zip file.',
            type: 'error',
            duration: 4000,
            position: 'top-right',
          });
        };
      }
    },
    downloadUrlAsPromise: function (url) {
      try {
        return new Promise(function (resolve, reject) {
          var xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          xhr.responseType = 'arraybuffer';
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                resolve(xhr.response);
              } else {
                reject(new Error('Error for ' + url + ': ' + xhr.status));
              }
            }
          };
          xhr.send();
        });
      } catch {
        (err) => {
          this.loading = false;
          console.log(err);
          Vue.$toast.open({
            message: 'Error downloading file(s) for the .zip.',
            type: 'error',
            duration: 4000,
            position: 'top-right',
          });
        };
      }
    },
    addProduct: function (bvModalEvt) {
      try {
        //create the form object that we can validate and insert.
        let validatedForm = this.validateAddProduct();

        if (validatedForm) {
          validatedForm.approved = false;
          validatedForm.approvedBy = null;
          validatedForm.approvedTime = null;
          validatedForm.jobNum = this.jobNum;
          validatedForm.customer = this.jobCustomer.toLowerCase();
          validatedForm.org = sessionStorage.getItem('org');

          //set the time to noon of the timezone that it is added in to avoid the day changing
          validatedForm.date = new Date(
            moment(validatedForm.date).add(12, 'hours')
          );

          firestore()
            .collection('billableProducts')
            .add(validatedForm)
            .then((doc) => {
              //populate the rest of the object with the info that is needed for the table and edit.
              validatedForm.edit = doc.id;
              validatedForm.date = moment(validatedForm.date).format(
                'MMM DD, YY'
              );
              validatedForm.lineTotal = (
                Number(validatedForm.rate) * Number(validatedForm.quantity)
              ).toFixed(2);
              this.productsTableData.push(validatedForm);
              Swal.fire('Success!', 'Time added successfully.', 'success');
            })
            .catch((error) => {
              console.log(`Error adding time to job.`, error);
              Swal.fire(
                'Error!',
                'An error was encountered when inserting the time.',
                'error'
              );
            });
        } else {
          bvModalEvt.preventDefault();
        }
      } catch (err) {
        Swal.fire(
          'Error!',
          'An error was encountered when inserting the product.',
          'error'
        );
        console.log(err);
      }
    },
    validateAddTime: function () {
      try {
        //check if at least one of Hours, Overtime Hours, or Travel Time Hours has been entered
        let hoursValid = false;
        let regularValid = false;
        let overtimeValid = false;
        let travelValid = false;

        this.$refs.fieldTicketFormFields.forEach((field) => {
          if (
            field.field.name === 'Hours' &&
            this.editTimeHourType === 'regular' &&
            field.value !== null &&
            field.value.toString().trim() !== ''
          ) {
            hoursValid = true;
            regularValid = true;
          }
          if (
            field.field.name === 'Hours' &&
            this.editTimeHourType === 'overtime' &&
            field.value !== null &&
            field.value.toString().trim() !== ''
          ) {
            hoursValid = true;
            overtimeValid = true;
          }
          if (
            field.field.name === 'Hours' &&
            this.editTimeHourType === 'travel' &&
            field.value !== null &&
            field.value.toString().trim() !== ''
          ) {
            hoursValid = true;
            travelValid = true;
          }
          if (
            field.field.name === 'overtime' &&
            field.value !== null &&
            field.value.toString().trim() !== ''
          ) {
            hoursValid = true;
            overtimeValid = true;
          }
          if (
            field.field.name === 'travelTime' &&
            field.value !== null &&
            field.value.toString().trim() !== ''
          ) {
            hoursValid = true;
            travelValid = true;
          }
        });

        //check if an employee is selected.
        let flag = true;
        let retObj = {};

        this.$refs.fieldTicketFormFields.forEach((field) => {
          if (field.field.web === true) {
            //if the hours are valid(which means one of hours, overtime hours, or travel hours has been entered), we don't check to see if those fields are filled in
            if (
              !hoursValid ||
              (field.field.name !== 'Hours' &&
                field.field.name !== 'overtime' &&
                field.field.name !== 'travelTime')
            ) {
              //only validate the rates of the time types that are filled out
              if (field.field.name === 'Rate' && !regularValid) {
                field.hasError = false;
                field.errorMessage = null;
                retObj[field.field.name.toLowerCase()] = field.value;
                return;
              } else if (
                field.field.name === 'Overtime Rate' &&
                !overtimeValid
              ) {
                field.hasError = false;
                field.errorMessage = null;
                retObj[field.field.name.toLowerCase()] = field.value;
                return;
              } else if (field.field.name === 'Travel Rate' && !travelValid) {
                field.hasError = false;
                field.errorMessage = null;
                retObj[field.field.name.toLowerCase()] = field.value;
                return;
              } else {
                if (
                  field.value === null ||
                  field.value === undefined ||
                  field.value.toString().trim() == ''
                ) {
                  field.hasError = true;
                  field.errorMessage = 'Value cannot be empty.';
                  flag = false;
                } else {
                  field.hasError = false;
                  field.errorMessage = null;
                  retObj[field.field.name.toLowerCase()] = field.value;
                }
              }
            } else {
              field.hasError = false;
              field.errorMessage = null;
              retObj[field.field.name.toLowerCase()] = field.value;
            }
            if (
              field.field.type === 'number' &&
              flag === true &&
              field.value !== null
            ) {
              if (isNaN(field.value.toString().trim())) {
                field.hasError = true;
                field.errorMessage = 'Value is not a decimal.';
                flag = false;
              }
            }
          }
        });

        //if the form is valid, then we send back the form in an object to be inserted.
        if (flag) {
          return retObj;
        } else {
          return flag;
        }
      } catch (err) {
        console.log(err);
      }
    },
    validateEditTime: function () {
      try {
        //check if at least one of Hours, Overtime Hours, or Travel Time Hours has been entered
        let hoursValid = false;
        let regularValid = false;
        let overtimeValid = false;
        let travelValid = false;

        this.$refs.fieldTicketFormFields.forEach((field) => {
          if (
            field.field.name === 'Hours' &&
            this.editTimeHourType === 'regular' &&
            field.value !== null &&
            field.value.toString().trim() !== ''
          ) {
            hoursValid = true;
            regularValid = true;
          } else if (
            field.field.name === 'Hours' &&
            this.editTimeHourType === 'overtime' &&
            field.value !== null &&
            field.value.toString().trim() !== ''
          ) {
            hoursValid = true;
            overtimeValid = true;
          } else if (
            field.field.name === 'Hours' &&
            this.editTimeHourType === 'travel' &&
            field.value !== null &&
            field.value.toString().trim() !== ''
          ) {
            hoursValid = true;
            travelValid = true;
          } else if (
            field.field.name === 'overtime' &&
            field.value !== null &&
            field.value.toString().trim() !== ''
          ) {
            hoursValid = true;
            overtimeValid = true;
          } else if (
            field.field.name === 'travelTime' &&
            field.value !== null &&
            field.value.toString().trim() !== ''
          ) {
            hoursValid = true;
            travelValid = true;
          }
        });

        //check if an employee is selected.
        let flag = true;
        let retObj = {};

        this.$refs.fieldTicketFormFields.forEach((field) => {
          if (field.field.web === true) {
            //if the hours are valid(which means one of hours, overtime hours, or travel hours has been entered), we don't check to see if those fields are filled in
            if (
              !hoursValid ||
              (field.field.name !== 'Hours' &&
                field.field.name !== 'overtime' &&
                field.field.name !== 'travelTime')
            ) {
              //only validate the rates of the time types that are filled out
              if (field.field.name === 'Rate' && !regularValid) {
                field.hasError = false;
                field.errorMessage = null;
                retObj[field.field.name.toLowerCase()] = field.value;
                return;
              } else if (
                field.field.name === 'Overtime Rate' &&
                !overtimeValid
              ) {
                field.hasError = false;
                field.errorMessage = null;
                retObj[field.field.name.toLowerCase()] = field.value;
                return;
              } else if (field.field.name === 'Travel Rate' && !travelValid) {
                field.hasError = false;
                field.errorMessage = null;
                retObj[field.field.name.toLowerCase()] = field.value;
                return;
              } else {
                if (
                  field.value === null ||
                  field.value === undefined ||
                  field.value.toString().trim() == ''
                ) {
                  field.hasError = true;
                  field.errorMessage = 'Value cannot be empty.';
                  flag = false;
                } else {
                  field.hasError = false;
                  field.errorMessage = null;
                  retObj[field.field.name.toLowerCase()] = field.value;
                }
              }
            } else {
              field.hasError = false;
              field.errorMessage = null;
              if (
                (field.field.name === 'Hours' ||
                  field.field.name === 'overtime' ||
                  field.field.name === 'travelTime') &&
                field.value !== undefined &&
                field.value !== null &&
                field.value.trim() !== ''
              ) {
                retObj['hours'] = field.value;

                if (overtimeValid) {
                  retObj['overtime'] = true;
                  retObj['travelTime'] = false;
                } else if (travelValid) {
                  retObj['travelTime'] = true;
                  retObj['overtime'] = false;
                } else {
                  retObj['overtime'] = false;
                  retObj['travelTime'] = false;
                }
              } else {
                if (
                  field.field.name !== 'overtime' &&
                  field.field.name !== 'travelTime'
                ) {
                  retObj[field.field.name.toLowerCase()] = field.value;
                }
              }
            }
            if (
              field.field.type === 'number' &&
              flag === true &&
              field.value !== null
            ) {
              if (isNaN(field.value.toString().trim())) {
                field.hasError = true;
                field.errorMessage = 'Value is not a decimal.';
                flag = false;
              }
            }
          }
        });

        //if the form is valid, then we send back the form in an object to be inserted.
        if (flag) {
          return retObj;
        } else {
          return flag;
        }
      } catch (err) {
        console.log(err);
      }
    },
    validateAddProduct: function () {
      try {
        let flag = true;
        let retObj = {};

        this.$refs.productFormFields.forEach((field) => {
          if (field.field.web === true) {
            if (
              field.value === null ||
              field.value === undefined ||
              field.value.toString().trim() == ''
            ) {
              field.hasError = true;
              field.errorMessage = 'Value cannot be empty.';
              flag = false;
            } else {
              field.hasError = false;
              field.errorMessage = null;
              retObj[field.field.name.toLowerCase()] = field.value;
            }
            if (field.field.type === 'number' && flag === true) {
              if (isNaN(field.value.toString().trim())) {
                field.hasError = true;
                field.errorMessage = 'Value is not a decimal.';
                flag = false;
              }
            }
          }
        });

        //if the form is valid, then we send back the form in an object to be inserted.
        if (flag) {
          return retObj;
        } else {
          return flag;
        }
      } catch (err) {
        console.log(err);
      }
    },
    resetAddTimeModal: function () {
      this.addTimeModal = false;
      this.fieldTicketForm = JSON.parse(
        JSON.stringify(this.fieldTicketFormInitial)
      );
    },
    showAddTimeModal: async function () {
      // when modal is opened, we need to make sure the fields are reset because they get modified when using edit modal
      this.addTimeModal = true;
      this.fieldTicketFormInitial = JSON.parse(
        JSON.stringify(this.fieldTicketForm)
      );
    },
    resetEditTimeModal: function () {
      this.fieldTicketForm = JSON.parse(
        JSON.stringify(this.fieldTicketFormInitial)
      );
      this.fieldTicketFormInitial = [];
      this.timeTransitionJob = null;
    },
    showEditTimeModal: async function () {
      this.fieldTicketFormEdit = JSON.parse(
        JSON.stringify(this.fieldTicketForm)
      );
      let hoursTableIndex = this.hoursTableData.findIndex(
        (x) => x.edit === this.editTime_id
      );

      // set value of modals hours checkboxes
      if (this.hoursTableData[hoursTableIndex].overtime) {
        this.editTimeHourType = 'overtime';
      } else if (this.hoursTableData[hoursTableIndex].travelTime) {
        this.editTimeHourType = 'travel';
      } else {
        this.editTimeHourType = 'regular';
      }

      let overtimeFlag = false;
      let travelFlag = false;

      let overtimeRateIndex = this.fieldTicketFormEdit.findIndex(
        (x) => x.name === 'Overtime Rate'
      );
      if (overtimeRateIndex !== -1) {
        this.fieldTicketFormEdit.splice(overtimeRateIndex, 1);
      }

      let travelRateIndex = this.fieldTicketFormEdit.findIndex(
        (x) => x.name === 'Travel Rate'
      );
      if (travelRateIndex !== -1) {
        this.fieldTicketFormEdit.splice(travelRateIndex, 1);
      }

      this.fieldTicketFormInitial = JSON.parse(
        JSON.stringify(this.fieldTicketForm)
      );
      if (
        this.companySettings.mobileOvertimeField ||
        this.companySettings.mobileTravelTimeField
      ) {
        //check if the overtime field or the travel time field is set to true
        // check hours as well because when using the switch hour type checkboxes the FieldTicketFormFields ref
        // gets modified to just have one field with name: Hours and the label set to the type of hours, this just gets spliced
        // with the appropiate label
        this.$refs.fieldTicketFormFields.forEach((field) => {
          let name = field.field.name.toLowerCase();
          if (field.field.web) {
            let index = this.hoursTableData.findIndex(
              (o) => o['edit'] == this.editTime_id
            );
            if (name === 'overtime') {
              if (this.hoursTableData[index].overtime) {
                overtimeFlag = true;
                this.editTimeHourType = 'overtime';
              } else {
                overtimeFlag = false;
                this.editTimeHourType = 'regular';
              }
            } else if (name === 'traveltime') {
              if (this.hoursTableData[index].travelTime) {
                travelFlag = true;
                this.editTimeHourType = 'travel';
              }
            } else if (name === 'hours') {
              if (this.hoursTableData[index].overtime) {
                overtimeFlag = true;
                this.editTimeHourType = 'overtime';
              } else if (this.hoursTableData[index].travelTime) {
                travelFlag = true;
                this.editTimeHourType = 'travel';
              } else {
                overtimeFlag = false;
                this.editTimeHourType = 'regular';
              }
            }
          }
        });
        // if ot or travel flag is set to true, remove the hours field and the other unused field
        if (overtimeFlag) {
          let hoursIndex = this.fieldTicketFormEdit.findIndex(
            (x) => x.label === 'Hours'
          );
          if (hoursIndex !== -1) {
            this.fieldTicketFormEdit.splice(hoursIndex, 1);
          }

          let travelIndex = this.fieldTicketFormEdit.findIndex(
            (x) => x.name === 'travelTime'
          );
          if (travelIndex !== -1) {
            this.fieldTicketFormEdit.splice(travelIndex, 1);
          }
        } else if (travelFlag) {
          let hoursIndex = this.fieldTicketFormEdit.findIndex(
            (x) => x.label === 'Hours'
          );
          if (hoursIndex !== -1) {
            this.fieldTicketFormEdit.splice(hoursIndex, 1);
          }

          let overtimeIndex = this.fieldTicketFormEdit.findIndex(
            (x) => x.name === 'overtime'
          );
          if (overtimeIndex !== -1) {
            this.fieldTicketFormEdit.splice(overtimeIndex, 1);
          }
        } else {
          let overtimeIndex = this.fieldTicketFormEdit.findIndex(
            (x) => x.label === 'Overtime Hours'
          );

          if (overtimeIndex !== -1) {
            this.fieldTicketFormEdit.splice(overtimeIndex, 1);
          }

          let travelIndex = this.fieldTicketFormEdit.findIndex(
            (x) => x.label === 'Travel Time Hours'
          );
          if (travelIndex !== -1) {
            this.fieldTicketFormEdit.splice(travelIndex, 1);
          }
        }
      }
      //wait for dynamic-controls ref to update and then set the values
      await Vue.nextTick();
      this.$refs.fieldTicketFormFields.forEach((field) => {
        if (field.field.web) {
          let index = this.hoursTableData.findIndex(
            (o) => o['edit'] == this.editTime_id
          );
          let name = field.field.name.toLowerCase();

          //we need to cast as date, if the input type is a datetime.
          if (field.field.type === 'dateTime') {
            field.value = new Date(this.hoursTableData[index][name]);
          } else {
            field.value = this.hoursTableData[index][name];
          }

          //change the overtime field or travel time field if the time is marked as such
          if (overtimeFlag) {
            if (name === 'overtime') {
              field.value = this.hoursTableData[index].hours;
            }
          } else if (travelFlag) {
            if (name === 'traveltime') {
              field.value = this.hoursTableData[index].hours;
            }
          }
        }
      });
    },
    showEditProductModal: function () {
      this.$refs.productFormFields.forEach((field) => {
        if (field.field.web) {
          let index = this.productsTableData.findIndex(
            (o) => o['edit'] == this.editProduct_id
          );
          let name = field.field.name.toLowerCase();
          //we need to cast as date, if the input type is a datetime.
          if (field.field.type === 'dateTime') {
            field.value = new Date(this.productsTableData[index][name]);
          } else {
            field.value = this.productsTableData[index][name];
          }
        }
      });
    },
    editProduct: function (index, id, name, uid) {
      //, context, name, date, hours, description
      this.editProduct_id = id;
      this.editProduct_selectedEmployee = { name: name, uid: uid };
      this.editProduct_index = index;
    },
    editTime: function (index, id, name, uid) {
      //, context, name, date, hours, description
      this.editTime_id = id;
      this.editTime_selectedEmployee = { name: name, uid: uid };
      this.editTime_index = index;
    },
    moveTime: function (id, employee, date, description) {
      this.moveTimeObj = {
        id: id,
        employee: employee,
        date: date,
        description: description,
      };
    },
    submitEditTime: async function (bvModalEvt) {
      //create the form object that we can validate and insert.
      let validatedForm = this.validateEditTime();
      let updatedTableData = {};

      if (validatedForm) {
        validatedForm.customer = this.jobCustomer.toLowerCase();
        validatedForm.user = this.editTime_selectedEmployee.uid;
        validatedForm.employee = this.editTime_selectedEmployee.name;

        //set the time to noon of the timezone that it is added in to avoid the day changing
        validatedForm.date = new Date(
          moment(validatedForm.date).add(12, 'hours')
        );

        // add updated ot, travel flags to validated form
        if (this.editTimeHourType === 'overtime') {
          validatedForm['overtime'] = true;
          validatedForm['travelTime'] = false;
        } else if (this.editTimeHourType === 'travel') {
          validatedForm['overtime'] = false;
          validatedForm['travelTime'] = true;
        } else {
          validatedForm['overtime'] = false;
          validatedForm['travelTime'] = false;
        }

        firestore()
          .collection('times')
          .doc(this.editTime_id)
          .update(validatedForm)
          .then(() => {
            // update badge for local
            if (this.editTimeHourType === 'overtime') {
              validatedForm['type'] = 'ot';
            } else if (this.editTimeHourType === 'travel') {
              validatedForm['type'] = 'tt';
            } else {
              validatedForm['type'] = 'reg';
            }
            validatedForm.edit = this.editTime_id;
            validatedForm.date = moment(validatedForm.date).format(
              'MMM DD, YY'
            );
            validatedForm.lineTotal = (
              Number(validatedForm.rate) * Number(validatedForm.hours)
            ).toFixed(2);

            //the format that the table is in is an array of empty arrays with property values set on them. I matched that format but we might want to think about switching it at some point
            for (const field in validatedForm) {
              if (field === 'user') {
                updatedTableData['uid'] = validatedForm[field];
              } else {
                updatedTableData[field] = validatedForm[field];
              }
            }
            let i = this.hoursTableData.findIndex(
              (o) => o.edit == this.editTime_id
            );
            updatedTableData = {
              ...updatedTableData,
              approved: this.hoursTableData[i].approved,
              approvedBy: this.hoursTableData[i].approvedBy,
              approvedTime: this.hoursTableData[i].approvedTime,
              billable: this.hoursTableData[i].billable,
              billableApprovedBy: this.hoursTableData[i].billableApprovedBy,
              billableApprovedTime: this.hoursTableData[i].billableApprovedTime,
            };
            //apparently updating arrays by index does not keep the reactivity, so we need to splice a new value into the array.
            this.hoursTableData.splice(i, 1, updatedTableData);

            // close modal and display user feedback
            this.$refs['modal-editTime'].hide();
            Vue.$toast.open({
              message: 'Time edited successfully',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          })
          .catch(() => {
            Swal.fire(
              'Error!',
              'An error was encountered when updating the record.',
              'error'
            );
          });
      } else {
        bvModalEvt.preventDefault();
      }
    },
    submitEditProduct: async function (bvModalEvt) {
      //create the form object that we can validate and insert.
      let validatedForm = this.validateAddProduct();
      // let user = JSON.parse(sessionStorage.authUser);
      if (validatedForm) {
        validatedForm.approved = false;
        validatedForm.approvedBy = null;
        validatedForm.approvedTime = null;
        // validatedForm.user = { name: user.displayName, uid: user.uid };

        //set the time to noon of the timezone that it is added in to avoid the day changing
        validatedForm.date = new Date(
          moment(validatedForm.date).add(12, 'hours')
        );

        firestore()
          .collection('billableProducts')
          .doc(this.editProduct_id)
          .update(validatedForm)
          .then(() => {
            validatedForm.edit = this.editProduct_id;
            validatedForm.date = moment(validatedForm.date).format(
              'MMM DD, YY'
            );
            // validatedForm.user = user.displayName;
            validatedForm.lineTotal = (
              Number(validatedForm.rate) * Number(validatedForm.quantity)
            ).toFixed(2);

            let i = this.productsTableData.findIndex(
              (o) => o.edit == this.editProduct_id
            );
            this.productsTableData.splice(i, 1, validatedForm);
            Swal.fire('Success!', 'The update was successful.', 'success');
          })
          .catch(() => {
            Swal.fire(
              'Error!',
              'An error was encountered when updating the record.',
              'error'
            );
          });
      } else {
        bvModalEvt.preventDefault();
      }
    },
    deleteTime: function (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This item will be deleted permanently',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          firestore()
            .collection('times')
            .doc(id)
            .delete()
            .then(() => {
              this.hoursTableData = this.hoursTableData.filter(function (obj) {
                return obj.edit !== id;
              });

              Swal.fire(
                'Deleted!',
                'The selected time was successfully deleted.',
                'success'
              );
            })
            .catch(() => {
              Swal.fire(
                'Error!',
                'An error was encounted when deleteing the record.',
                'error'
              );
            });
        }
      });
    },
    deleteProduct: function (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This item will be deleted permanently',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          firestore()
            .collection('billableProducts')
            .doc(id)
            .delete()
            .then(() => {
              this.productsTableData = this.productsTableData.filter(function (
                obj
              ) {
                return obj.edit !== id;
              });
              Swal.fire(
                'Deleted!',
                'The selected time was successfully deleted.',
                'success'
              );
            })
            .catch(() => {
              Swal.fire(
                'Error!',
                'An error was encounted when deleting the record.',
                'error'
              );
            });
        }
      });
    },
    deleteJob: function () {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This job will be deleted permanently',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          firestore()
            .collection('jobs')
            .doc(this.jobID)
            .delete()
            .then(() => {
              Swal.fire(
                'Deleted!',
                'The job was successfully deleted.',
                'success'
              );
              this.$router.push({
                path: `/production/jobs/searchJobs`,
              });
            })
            .catch(() => {
              Swal.fire(
                'Error!',
                'An error was encountered while deleteing the job.',
                'error'
              );
            });
        }
      });
    },
    checkControls() {
      //check if there are any active controls on this job
      let flag = false;
      if (this.controls) {
        for (const control in this.controls) {
          let data = this.controls[control];
          for (const key in data) {
            if (key === 'active' && data[key] === true) {
              flag = true;
            }
          }
        }
      } else {
        return false;
      }
      return flag;
    },
    validateEntry(entry) {
      //check that value inputted is a number
      if (entry === null) {
        return null;
      }
      if (!isNaN(Number(entry))) {
        return true;
      } else {
        return false;
      }
    },
    editJob: function (customer, date, description) {
      //clear the customer list and get the customers again when the modal is open. If we don't clear the list we will get duplicates.
      this.customers = [];
      getCustomers()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.customers.push(doc.data().displayName);
          });
          this.editJob_selectedCustomer = customer;
          this.editJob_date = new Date(date);
          this.editJob_desc = description;
          this.editJob_supervisor = this.supervisor;
          this.editJob_jobType = this.jobType;
          this.editJob_jobQuote = this.jobQuote;
          this.editJob_selectedRevenueType = this.jobRevenueCalculations;
          this.editJob_jobDepartment = this.jobDepartment;
          this.editJob_futureTimesEnabled = this.futureTimesEnabled;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    validateEditJob: function () {
      //check if an employee is selected.
      let flag = true;
      if (this.editJob_selectedCustomer == null) {
        this.editJob_errors.customerError = true;
        this.editJob_errors.customerMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.editJob_errors.customerError = false;
        this.editJob_errors.customerMessage = null;
      }
      //check if the date is valid and not empty
      if (this.editJob_date == null) {
        this.editJob_errors.dateError = true;
        this.editJob_errors.dateMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.editJob_errors.dateError = false;
        this.editJob_errors.dateMessage = null;
      }
      //check that the description is not empty.
      if (this.editJob_desc == null || this.editJob_desc.trim() == '') {
        this.editJob_errors.descError = true;
        this.editJob_errors.descMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.editJob_errors.descError = false;
        this.editJob_errors.descMessage = null;
      }
      return flag;
    },
    submitJobEdit: function (bvModalEvt) {
      let flag = true;

      if (this.validateEditJob() && flag) {
        firestore()
          .collection('jobs')
          .doc(this.jobID)
          .update({
            customerDisplayName: this.editJob_selectedCustomer,
            customer: this.editJob_selectedCustomer.toLowerCase(),
            date: new Date(this.editJob_date),
            description: this.editJob_desc,
            supervisor: this.editJob_supervisor,
            jobType: this.editJob_jobType,
            jobRevenueCalculations: this.editJob_selectedRevenueType,
            jobQuote:
              this.editJob_jobType === 'Quoted (Fixed Rate)'
                ? this.editJob_jobQuote
                  ? this.editJob_jobQuote
                  : '0'
                : null,
            jobDepartment: this.editJob_jobDepartment === '' ? null : this.editJob_jobDepartment,
            futureTimesEnabled: this.editJob_futureTimesEnabled

            // controls: atLeastOneControlEnabled ? mappedControls : null,
          })
          .then(() => {
            this.jobCustomer = this.editJob_selectedCustomer;
            this.jobDate = moment(this.editJob_date).format('MMM DD, YY');
            this.jobDesc = this.editJob_desc;
            this.supervisor = this.editJob_supervisor;
            this.jobType = this.editJob_jobType;
            this.jobRevenueCalculations = this.editJob_selectedRevenueType;
            this.jobQuote = this.editJob_jobQuote ? this.editJob_jobQuote : '0';
            this.jobDepartment = this.editJob_jobDepartment;
            this.futureTimesEnabled = this.editJob_futureTimesEnabled;
            Swal.fire('Success!', 'The update was successful.', 'success');
          })
          .catch(() => {
            Swal.fire(
              'Error!',
              'An error was encountered when updating the job.',
              'error'
            );
          });

        if (this.editJob_selectedCustomer != this.jobCustomer) {
          firestore()
            .collection('times')
            .where('jobNum', '==', Number(this.jobNum))
            .where('org', '==', sessionStorage.getItem('org'))
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                firestore()
                  .collection('times')
                  .doc(doc.id)
                  .update({
                    customer: this.editJob_selectedCustomer.toLowerCase(),
                  })
                  .catch(() => {
                    Swal.fire(
                      'Error!',
                      'An error was encountered when updating the associated times.',
                      'error'
                    );
                  });
              });
            })
            .catch(() => {
              console.log(`Error updating times`);
            });
        }
      } else {
        bvModalEvt.preventDefault();
      }
    },
    submitBudgetEdit: function (bvModalEvt) {
      let categoriesEnabled = false;
      let categoriesEnabledInitial = false;
      let procurementsEnabled = false;
      if (this.editedControlsEnabled) {
        categoriesEnabled =
          this.$refs.jobBudgetsComponent.childCategoryBudgetsEnabled;
        categoriesEnabledInitial =
          this.$refs.jobBudgetsComponent.childCategoryBudgetsEnabledInitial;
        procurementsEnabled = this.$refs.jobBudgetsComponent.controls
          .procurements
          ? this.$refs.jobBudgetsComponent.controls.procurements.active
          : false;
      }

      let flag = true;
      // let atLeastOneControlEnabled = false;
      let mappedControls = JSON.parse(JSON.stringify(this.editedControls));
      // let mappedControls = this.editedControls;
      // let mappedProcurementControls = this.editedProcurementControls;
      let mappedProcurementControls = JSON.parse(
        JSON.stringify(this.editedProcurementControls)
      );

      //if the controls are enabled, loop them.
      if (this.editedControlsEnabled) {
        //loop the controls and validate each entry to ensure it is a avalid number.
        for (const control in mappedControls) {
          let data = mappedControls[control];
          if (this.validateEntry(data.value) === false) {
            if (data.value !== '') {
              flag = false;
            }
          }
          if (data.active) {
            if (data.value === null || data.value.trim() === '') {
              data.active = false;
              data.value = null;
            }
          } else {
            //if the budget item is not active, then remove the budget amount.
            data.value = null;
          }

          //remove the types so they aren't added to the db.
          delete data.types;
          delete data.unitOfMeasures;
        }

        for (const control in mappedProcurementControls) {
          let data = mappedProcurementControls[control];
          if (this.validateEntry(data.value) === false) {
            if (data.value !== '') {
              flag = false;
            }
          }
          if (data.active) {
            // atLeastOneControlEnabled = true;
            if (data.value === null || data.value.trim() === '') {
              data.active = false;
              data.value = null;
            }
          } else {
            //if the budget item is not active, then remove the budget amount.
            data.value = null;
          }

          //remove the types so they aren't added to the db.
          delete data.types;
          delete data.unitOfMeasures;
        }
      }

      let user = JSON.parse(sessionStorage.authUser);
      let updatedBudgetRevisions = this.budgetRevisions;
      //check if the budget has been changed from a flat rate budget to a category budget or vice versa
      if (categoriesEnabled !== categoriesEnabledInitial) {
        let revision = {
          budgetTypeChanged: true,
          formerBudget: `${categoriesEnabled ? 'flat rate' : 'category'}`,
          revisedBudget: `${categoriesEnabled ? 'category' : 'flat rate'}`,
          description: null,
          category: null,
          user: { name: user.displayName, id: user.uid },
          date: new Date(Date.now()),
        };
        updatedBudgetRevisions.push(revision);
      }
      //check if the budget has been revised and push the new revision if it has
      //flat rate revision
      else if (!categoriesEnabled) {
        if (
          this.$refs.jobBudgetsComponent.childJobBudgetInitial &&
          this.$refs.jobBudgetsComponent.childJobBudgetInitial !==
            this.jobBudget
        ) {
          let revision = {
            budgetTypeChanged: false,
            formerBudget: this.$refs.jobBudgetsComponent.childJobBudgetInitial,
            revisedBudget: this.jobBudget,
            description: this.$refs.jobBudgetsComponent.revisionDescription,
            category: null,
            user: { name: user.displayName, id: user.uid },
            date: new Date(Date.now()),
          };
          updatedBudgetRevisions.push(revision);
        }
      }
      //category revisions
      else {
        for (const control in mappedControls) {
          let data = mappedControls[control];
          if (
            this.$refs.jobBudgetsComponent.controlsInitial[control].value &&
            data.value !==
              this.$refs.jobBudgetsComponent.controlsInitial[control].value
          ) {
            let revision = {
              budgetTypeChanged: false,
              formerBudget:
                this.$refs.jobBudgetsComponent.controlsInitial[control].value,
              revisedBudget: data.value,
              description:
                this.$refs.jobBudgetsComponent.categoryRevisions[control],
              category: control,
              user: { name: user.displayName, id: user.uid },
              date: new Date(Date.now()),
            };
            updatedBudgetRevisions.push(revision);
          }
        }
      }

      if (flag) {
        firestore()
          .collection('jobs')
          .doc(this.jobID)
          .update({
            controls: categoriesEnabled
              ? mappedControls
              : this.originalControls,
            procurementControls: procurementsEnabled
              ? mappedProcurementControls
              : this.originalProcurementControls,
            jobBudget: this.editedControlsEnabled
              ? categoriesEnabled
                ? null
                : this.jobBudget
              : null,
            budgetRevisions: updatedBudgetRevisions,
          })
          .then(() => {
            this.controlsEnabled = this.editedControlsEnabled;
            this.controls = JSON.parse(JSON.stringify(this.editedControls));
            this.procurementControls = JSON.parse(
              JSON.stringify(this.editedProcurementControls)
            );
            //re-apply the budget calculations
            this.applyRevenueBudget();
            this.applyExpensesBudget();
            if (categoriesEnabled) {
              this.jobBudget = null;
            }
            this.budgetRevisions = updatedBudgetRevisions;
            this.jobBudgetEditComplete = true;
            Swal.fire('Success!', 'The update was successful.', 'success');
          })
          .catch((error) => {
            console.log(error);
            Swal.fire(
              'Error!',
              'An error was encountered when updating the budget.',
              'error'
            );
          });
      } else {
        bvModalEvt.preventDefault();
      }
    },
    submitCreateInvoice: async function (bvModalEvt) {
      if (this.validateCreateInvoice()) {
        //get the specified invoice template, if custom invoice templates are enabled.
        //TODO: check to see if custom invoice templates are enabled.
        let invoiceTemplate = [];
        await getInvoiceTemplate('invoiceTemplate')
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              //loop through the document and get the inputs.
              invoiceTemplate = doc.data().inputs;
            });
          })
          .catch((err) => {
            console.log(err);
          });

        //filter the times to get between the date ranges.
        let filteredTimesArray = this.hoursTableData.filter((time) =>
          moment(time.date).isBetween(
            moment(this.createInvoice_startDate).startOf('day'),
            moment(this.createInvoice_endDate).endOf('day'),
            undefined,
            '[]'
          )
        );
        //filter times excluded from billing
        filteredTimesArray = filteredTimesArray.filter(
          (time) => time.billable !== true
        );
        //filter the products to get between the date ranges.
        let filteredProductsArray = this.productsTableData.filter((product) =>
          moment(product.date).isBetween(
            moment(this.createInvoice_startDate).startOf('day'),
            moment(this.createInvoice_endDate).endOf('day'),
            undefined,
            '[]'
          )
        );
        //filter products excluded from billing
        filteredProductsArray = filteredProductsArray.filter(
          (product) => product.billable !== true
        );
        //filter the procurements to get between the date ranges.
        let filteredProcurementArray =
          this.$refs.procurementTable.tableData.filter((procurement) =>
            moment(procurement.date).isBetween(
              moment(this.createInvoice_startDate).startOf('day'),
              moment(this.createInvoice_endDate).endOf('day'),
              undefined,
              '[]'
            )
          );
        //filter procurements excluded from billing
        filteredProcurementArray = filteredProcurementArray.filter(
          (procurement) => procurement.billable.value !== true
        );
        let invoiceTemplateItems = [];
        let invoiceTemplateTotals = [];
        if (invoiceTemplate.length >= 1) {
          //loop the filtered array and format it to the invoice template, if there is one.
          filteredTimesArray.forEach((time) => {
            let formattedTime = {};
            //loop the invoice template to see what fields we need from each time.
            invoiceTemplate.forEach((templateItem) => {
              //check the conditions of the field.
              if (templateItem.conditions != undefined) {
                //loop the conditions and check if our value satifies all of them.
                let conditionPassed = true;

                templateItem.conditions.forEach((condition) => {
                  if (condition.operator == '==') {
                    if (time[condition.name] != condition.value) {
                      //condition not met, don't show.
                      conditionPassed = false;
                      formattedTime[templateItem.displayName] = '';
                    }
                  } else if (condition.operator == '!=') {
                    if (time[condition.name] == condition.value) {
                      //condition not met, don't show.
                      conditionPassed = false;
                      formattedTime[templateItem.displayName] = '';
                    }
                  } else if (condition.operator == 'or') {
                    // this means the time value can be equal to any of the condition values passed in as a comma seperated string
                    // eg: "54,57", the time value can be equal to 54 or 57
                    const conditionValueSplitArray = condition.value.split(',');
                    let atLeastOneConditionValueMatched = false;
                    conditionValueSplitArray.forEach((value)=>{
                      if (time[condition.name] == value) {
                        atLeastOneConditionValueMatched = true;
                      }
                    });

                    if(!atLeastOneConditionValueMatched){
                      //condition not met, don't show.
                      conditionPassed = false;
                      formattedTime[templateItem.displayName] = '';
                    }
                  }
                });

                //if the condition passed, do our math.
                if (conditionPassed) {
                  //do the stuff.
                  if (templateItem.type == 'single') {
                    formattedTime[templateItem.displayName] =
                      time[templateItem.name];
                  } else if (templateItem.type == 'calculated') {
                    //check if we are calculating using a fixedValue or another field.
                    if (
                      templateItem.data[2].name == undefined &&
                      templateItem.data[2].fixedValue != undefined
                    ) {
                      //we are using a fixed values
                      if (templateItem.data[1].operator == '*') {
                        formattedTime[templateItem.displayName] =
                          time[templateItem.data[0].name] *
                          templateItem.data[2].fixedValue;
                      } else if (templateItem.data[1].operator == '+') {
                        formattedTime[templateItem.displayName] =
                          time[templateItem.data[0].name] +
                          templateItem.data[2].fixedValue;
                      } else if (templateItem.data[1].operator == '-') {
                        formattedTime[templateItem.displayName] =
                          time[templateItem.data[0].name] -
                          templateItem.data[2].fixedValue;
                      } else if (templateItem.data[1].operator == '/') {
                        formattedTime[templateItem.displayName] =
                          time[templateItem.data[0].name] /
                          templateItem.data[2].fixedValue;
                      }
                    }
                    if (
                      templateItem.data[2].name != undefined &&
                      templateItem.data[2].fixedValue == undefined
                    ) {
                      if (templateItem.data[1].operator == '*') {
                        formattedTime[templateItem.displayName] =
                          time[templateItem.data[0].name] *
                          time[templateItem.data[2].name];
                      } else if (templateItem.data[1].operator == '+') {
                        formattedTime[templateItem.displayName] =
                          time[templateItem.data[0].name] +
                          time[templateItem.data[2].name];
                      } else if (templateItem.data[1].operator == '-') {
                        formattedTime[templateItem.displayName] =
                          time[templateItem.data[0].name] -
                          time[templateItem.data[2].name];
                      } else if (templateItem.data[1].operator == '/') {
                        formattedTime[templateItem.displayName] =
                          time[templateItem.data[0].name] /
                          time[templateItem.data[2].name];
                      }
                    }
                  } else if (templateItem.type == 'empty') {
                    formattedTime[templateItem.displayName] = '';
                  }
                }
              } else {
                if (templateItem.type == 'single') {
                  formattedTime[templateItem.displayName] =
                    time[templateItem.name];
                } else if (templateItem.type == 'calculated') {
                  if (templateItem.data[1].operator == '*') {
                    formattedTime[templateItem.displayName] =
                      time[templateItem.data[0].name] *
                      time[templateItem.data[2].name];
                  } else if (templateItem.data[1].operator == '+') {
                    formattedTime[templateItem.displayName] =
                      time[templateItem.data[0].name] +
                      time[templateItem.data[2].name];
                  } else if (templateItem.data[1].operator == '-') {
                    formattedTime[templateItem.displayName] =
                      time[templateItem.data[0].name] -
                      time[templateItem.data[2].name];
                  } else if (templateItem.data[1].operator == '/') {
                    formattedTime[templateItem.displayName] =
                      time[templateItem.data[0].name] /
                      time[templateItem.data[2].name];
                  }
                } else if (templateItem.type == 'empty') {
                  formattedTime[templateItem.displayName] = '';
                }
              }

              //check if the field is a sum field. If it is, we need to start summing the column
              let index = invoiceTemplateTotals.findIndex(
                (o) => o.name == templateItem.name
              );

              if (templateItem.sum == true) {
                //check to see if the total for the column is already in the collection.
                if (index >= 0) {
                  //item exists in array.
                  if (!isNaN(Number(formattedTime[templateItem.displayName]))) {
                    invoiceTemplateTotals[index].subtotal =
                      Number(invoiceTemplateTotals[index].subtotal) +
                      Number(formattedTime[templateItem.displayName]);
                  }
                } else {
                  //item doesn't exists. add it to the array.
                  invoiceTemplateTotals.push({
                    name: templateItem.name,
                    subtotal:
                      formattedTime[templateItem.displayName] == ''
                        ? 0
                        : formattedTime[templateItem.displayName],
                    gst: 0,
                    total: 0,
                    sum: true,
                  });
                }
              } else {
                if (index == -1) {
                  //item is not in the array.
                  invoiceTemplateTotals.push({
                    name: templateItem.name,
                    subtotal: 0,
                    gst: 0,
                    total: 0,
                    sum: false,
                  });
                }
              }
            });
            invoiceTemplateItems.push(formattedTime);
          });

          //do the same for the products array
          filteredProductsArray.forEach((product) => {
            let formattedProduct = {};
            //loop the invoice template to see what fields we need from each product.
            invoiceTemplate.forEach((templateItem) => {
              //check the conditions of the field.
              if (templateItem.conditions != undefined) {
                //loop the conditions and check if our value satisfies all of them.
                let conditionPassed = true;

                templateItem.conditions.forEach((condition) => {
                  if (condition.operator == '==') {
                    if (product[condition.name] != condition.value) {
                      //condition not met, don't show.
                      conditionPassed = false;
                      formattedProduct[templateItem.displayName] = '';
                    }
                  } else if (condition.operator == '!=') {
                    if (product[condition.name] == condition.value) {
                      //condition not met, don't show.
                      conditionPassed = false;
                      formattedProduct[templateItem.displayName] = '';
                    }
                  } else if (condition.operator == 'or') {
                    // this means the time value can be equal to any of the condition values passed in as a comma seperated string
                    // eg: "54,57", the time value can be equal to 54 or 57
                    const conditionValueSplitArray = condition.value.split(',');
                    let atLeastOneConditionValueMatched = false;
                    conditionValueSplitArray.forEach((value)=>{
                      if (product[condition.name] == value) {
                        atLeastOneConditionValueMatched = true;
                      }
                    });

                    if(!atLeastOneConditionValueMatched){
                      //condition not met, don't show.
                      conditionPassed = false;
                      formattedProduct[templateItem.displayName] = '';
                    }
                  }
                });

                //if the condition passed, do our math.
                if (conditionPassed) {
                  //do the stuff.
                  if (templateItem.type == 'single') {
                    formattedProduct[templateItem.displayName] =
                      product[templateItem.name];
                  } else if (templateItem.type == 'calculated') {
                    //check if we are calculating using a fixedValue or another field.
                    if (
                      templateItem.data[2].name == undefined &&
                      templateItem.data[2].fixedValue != undefined
                    ) {
                      //we are using a fixed values
                      if (templateItem.data[1].operator == '*') {
                        formattedProduct[templateItem.displayName] =
                          product[templateItem.data[0].name] *
                          templateItem.data[2].fixedValue;
                      } else if (templateItem.data[1].operator == '+') {
                        formattedProduct[templateItem.displayName] =
                          product[templateItem.data[0].name] +
                          templateItem.data[2].fixedValue;
                      } else if (templateItem.data[1].operator == '-') {
                        formattedProduct[templateItem.displayName] =
                          product[templateItem.data[0].name] -
                          templateItem.data[2].fixedValue;
                      } else if (templateItem.data[1].operator == '/') {
                        formattedProduct[templateItem.displayName] =
                          product[templateItem.data[0].name] /
                          templateItem.data[2].fixedValue;
                      }
                    }
                    if (
                      templateItem.data[2].name != undefined &&
                      templateItem.data[2].fixedValue == undefined
                    ) {
                      if (templateItem.data[1].operator == '*') {
                        formattedProduct[templateItem.displayName] =
                          product[templateItem.data[0].name] *
                          product[templateItem.data[2].name];
                      } else if (templateItem.data[1].operator == '+') {
                        formattedProduct[templateItem.displayName] =
                          product[templateItem.data[0].name] +
                          product[templateItem.data[2].name];
                      } else if (templateItem.data[1].operator == '-') {
                        formattedProduct[templateItem.displayName] =
                          product[templateItem.data[0].name] -
                          product[templateItem.data[2].name];
                      } else if (templateItem.data[1].operator == '/') {
                        formattedProduct[templateItem.displayName] =
                          product[templateItem.data[0].name] /
                          product[templateItem.data[2].name];
                      }
                    }
                  } else if (templateItem.type == 'empty') {
                    formattedProduct[templateItem.displayName] = '';
                  }
                }
              } else {
                if (templateItem.type == 'single') {
                  formattedProduct[templateItem.displayName] =
                    product[templateItem.name];
                } else if (templateItem.type == 'calculated') {
                  if (templateItem.data[1].operator == '*') {
                    formattedProduct[templateItem.displayName] =
                      product[templateItem.data[0].name] *
                      product[templateItem.data[2].name];
                  } else if (templateItem.data[1].operator == '+') {
                    formattedProduct[templateItem.displayName] =
                      product[templateItem.data[0].name] +
                      product[templateItem.data[2].name];
                  } else if (templateItem.data[1].operator == '-') {
                    formattedProduct[templateItem.displayName] =
                      product[templateItem.data[0].name] -
                      product[templateItem.data[2].name];
                  } else if (templateItem.data[1].operator == '/') {
                    formattedProduct[templateItem.displayName] =
                      product[templateItem.data[0].name] /
                      product[templateItem.data[2].name];
                  }
                } else if (templateItem.type == 'empty') {
                  formattedProduct[templateItem.displayName] = '';
                }
              }

              //check if the field is a sum field. If it is, we need to start summing the column
              let index = invoiceTemplateTotals.findIndex(
                (o) => o.name == templateItem.name
              );

              if (templateItem.sum == true) {
                //check to see if the total for the column is already in the collection.
                if (index >= 0) {
                  //item exists in array.
                  if (
                    !isNaN(Number(formattedProduct[templateItem.displayName]))
                  ) {
                    invoiceTemplateTotals[index].subtotal =
                      Number(invoiceTemplateTotals[index].subtotal) +
                      Number(formattedProduct[templateItem.displayName]);
                  }
                } else {
                  //item doesn't exists. add it to the array.
                  invoiceTemplateTotals.push({
                    name: templateItem.name,
                    subtotal:
                      formattedProduct[templateItem.displayName] == ''
                        ? 0
                        : formattedProduct[templateItem.displayName],
                    gst: 0,
                    total: 0,
                    sum: true,
                  });
                }
              } else {
                if (index == -1) {
                  //item is not in the array.
                  invoiceTemplateTotals.push({
                    name: templateItem.name,
                    subtotal: 0,
                    gst: 0,
                    total: 0,
                    sum: false,
                  });
                }
              }
            });
            invoiceTemplateItems.push(formattedProduct);
          });

          //do the same for the procurement array
          filteredProcurementArray.forEach((procurement) => {
            let formattedProcurement = {};
            //loop the invoice template to see what fields we need from each product.
            invoiceTemplate.forEach((templateItem) => {
              //check the conditions of the field.
              if (templateItem.conditions != undefined) {
                //loop the conditions and check if our value satisfies all of them.
                let conditionPassed = true;

                templateItem.conditions.forEach((condition) => {
                  if (condition.operator == '==') {
                    if (procurement[condition.name] != condition.value) {
                      //condition not met, don't show.
                      conditionPassed = false;
                      formattedProcurement[templateItem.displayName] = '';
                    }
                  } else if (condition.operator == '!=') {
                    if (procurement[condition.name] == condition.value) {
                      //condition not met, don't show.
                      conditionPassed = false;
                      formattedProcurement[templateItem.displayName] = '';
                    }
                  } else if (condition.operator == 'or') {
                    // this means the time value can be equal to any of the condition values passed in as a comma seperated string
                    // eg: "54,57", the time value can be equal to 54 or 57
                    const conditionValueSplitArray = condition.value.split(',');
                    let atLeastOneConditionValueMatched = false;
                    conditionValueSplitArray.forEach((value)=>{
                      if (procurement[condition.name] == value) {
                        atLeastOneConditionValueMatched = true;
                      }
                    });

                    if(!atLeastOneConditionValueMatched){
                      //condition not met, don't show.
                      conditionPassed = false;
                      formattedProcurement[templateItem.displayName] = '';
                    }
                  }
                });

                //if the condition passed, do our math.
                if (conditionPassed) {
                  //do the stuff.
                  if (templateItem.type == 'single') {
                    formattedProcurement[templateItem.displayName] =
                      procurement[templateItem.name];
                  } else if (templateItem.type == 'calculated') {
                    //check if we are calculating using a fixedValue or another field.
                    if (
                      templateItem.data[2].name == undefined &&
                      templateItem.data[2].fixedValue != undefined
                    ) {
                      //we are using a fixed values
                      if (templateItem.data[1].operator == '*') {
                        formattedProcurement[templateItem.displayName] =
                          procurement[templateItem.data[0].name] *
                          templateItem.data[2].fixedValue;
                      } else if (templateItem.data[1].operator == '+') {
                        formattedProcurement[templateItem.displayName] =
                          procurement[templateItem.data[0].name] +
                          templateItem.data[2].fixedValue;
                      } else if (templateItem.data[1].operator == '-') {
                        formattedProcurement[templateItem.displayName] =
                          procurement[templateItem.data[0].name] -
                          templateItem.data[2].fixedValue;
                      } else if (templateItem.data[1].operator == '/') {
                        formattedProcurement[templateItem.displayName] =
                          procurement[templateItem.data[0].name] /
                          templateItem.data[2].fixedValue;
                      }
                    }
                    if (
                      templateItem.data[2].name != undefined &&
                      templateItem.data[2].fixedValue == undefined
                    ) {
                      if (templateItem.data[1].operator == '*') {
                        formattedProcurement[templateItem.displayName] =
                          procurement[templateItem.data[0].name] *
                          procurement[templateItem.data[2].name];
                      } else if (templateItem.data[1].operator == '+') {
                        formattedProcurement[templateItem.displayName] =
                          procurement[templateItem.data[0].name] +
                          procurement[templateItem.data[2].name];
                      } else if (templateItem.data[1].operator == '-') {
                        formattedProcurement[templateItem.displayName] =
                          procurement[templateItem.data[0].name] -
                          procurement[templateItem.data[2].name];
                      } else if (templateItem.data[1].operator == '/') {
                        formattedProcurement[templateItem.displayName] =
                          procurement[templateItem.data[0].name] /
                          procurement[templateItem.data[2].name];
                      }
                    }
                  } else if (templateItem.type == 'empty') {
                    formattedProcurement[templateItem.displayName] = '';
                  }
                }
              } else {
                if (templateItem.type == 'single') {
                  formattedProcurement[templateItem.displayName] =
                    procurement[templateItem.name];
                } else if (templateItem.type == 'calculated') {
                  if (templateItem.data[1].operator == '*') {
                    formattedProcurement[templateItem.displayName] =
                      procurement[templateItem.data[0].name] *
                      procurement[templateItem.data[2].name];
                  } else if (templateItem.data[1].operator == '+') {
                    formattedProcurement[templateItem.displayName] =
                      procurement[templateItem.data[0].name] +
                      procurement[templateItem.data[2].name];
                  } else if (templateItem.data[1].operator == '-') {
                    formattedProcurement[templateItem.displayName] =
                      procurement[templateItem.data[0].name] -
                      procurement[templateItem.data[2].name];
                  } else if (templateItem.data[1].operator == '/') {
                    formattedProcurement[templateItem.displayName] =
                      procurement[templateItem.data[0].name] /
                      procurement[templateItem.data[2].name];
                  }
                } else if (templateItem.type == 'empty') {
                  formattedProcurement[templateItem.displayName] = '';
                }
              }

              //check if the field is a sum field. If it is, we need to start summing the column
              let index = invoiceTemplateTotals.findIndex(
                (o) => o.name == templateItem.name
              );

              if (templateItem.sum == true) {
                //check to see if the total for the column is already in the collection.
                if (index >= 0) {
                  //item exists in array.
                  if (
                    !isNaN(
                      Number(formattedProcurement[templateItem.displayName])
                    )
                  ) {
                    invoiceTemplateTotals[index].subtotal =
                      Number(invoiceTemplateTotals[index].subtotal) +
                      Number(formattedProcurement[templateItem.displayName]);
                  }
                } else {
                  //item doesn't exists. add it to the array.
                  invoiceTemplateTotals.push({
                    name: templateItem.name,
                    subtotal:
                      formattedProcurement[templateItem.displayName] == ''
                        ? 0
                        : formattedProcurement[templateItem.displayName],
                    gst: 0,
                    total: 0,
                    sum: true,
                  });
                }
              } else {
                if (index == -1) {
                  //item is not in the array.
                  invoiceTemplateTotals.push({
                    name: templateItem.name,
                    subtotal: 0,
                    gst: 0,
                    total: 0,
                    sum: false,
                  });
                }
              }
            });
            invoiceTemplateItems.push(formattedProcurement);
          });
        }
        //sort the items by date
        invoiceTemplateItems.sort((a, b) => {
          let dateA = a.Date.toLowerCase();
          let dateB = b.Date.toLowerCase();
          if (dateA < dateB) {
            return -1;
          }
          if (dateA > dateB) {
            return 1;
          }
          return 0;
        });
        //send the user to the invoice page.
        this.$router.push({
          name: 'invoice',
          params: {
            jobNum: this.jobNum,
            jobCustomer: this.jobCustomer,
            date: this.createInvoice_endDate,
            times: filteredTimesArray,
            products: filteredProductsArray,
            procurements: filteredProcurementArray,
            jobDescription: this.jobDesc,
            jobDate: this.jobDate,
            invoiceTemplate: invoiceTemplate,
            invoiceTemplateItems: invoiceTemplateItems,
            invoiceTemplateTotals: invoiceTemplateTotals,
          },
        });
      } else {
        bvModalEvt.preventDefault();
      }
    },
    validateCreateInvoice: function () {
      let flag = true;
      //check if the date is valid and not empty
      if (this.createInvoice_startDate == null) {
        this.createInvoice_errors.startDateError = true;
        this.createInvoice_errors.startDateMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.createInvoice_errors.startDateError = false;
        this.createInvoice_errors.startDateMessage = null;
      }
      if (this.createInvoice_endDate == null) {
        this.createInvoice_errors.endDateError = true;
        this.createInvoice_errors.endDateMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.createInvoice_errors.endDateError = false;
        this.createInvoice_errors.endDateMessage = null;
      }
      return flag;
    },
    getEmployeesFunction: async function () {
      await getEmployees()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.employees.push({
              name: doc.data().displayName,
              uid: doc.id,
              rate: doc.data().rate,
              overtimeRate: doc.data().overtimeRate,
              travelRate: doc.data().travelTimeRate,
            });

            this.employeeOptions.push({
              name: doc.data().displayName,
              id: doc.id,
            });
          });
        })
        .catch(() => {
          console.log(`Error getting employees`);
        });
    },
    generateForm: async function () {
      await getFieldTicketForm()
        .then((querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            //start creating the form object.
            this.hoursFields.push({
              key: 'edit',
              sortable: false,
            });
            this.hoursFields.push({
              key: 'approved',
              sortable: true,
            });
            this.hoursFields.push({
              key: 'billable',
              label: 'Exclude From Billing',
              sortable: true,
            });


            for (let input of doc.data().inputs) {
              if (input.name == 'Employee') {
                this.fieldTicketForm.push({
                  name: input.name,
                  type: input.type,
                  web: input.web,
                  collection: this.employees,
                  label: input.label != undefined ? input.label : undefined,
                });

                const fieldObj = {
                  key: input.name.toLowerCase(),
                  label: input.label != undefined ? input.label : undefined,
                  sortable: true,
                };
                this.hoursFields.push(fieldObj);
              } else if (input.type == 'dropdown') {
                //go get the collection
                let collectionData = [];
                await getCustomCollectionDataFromName(input.collection)
                  .then((collectionSnapshot) => {
                    collectionSnapshot.forEach((collectionItem) => {
                      collectionData = collectionItem.data().values;
                    });
                  })
                  .catch(() => {
                    console.log(
                      `Error getting collection data for dynamic control ${input.name}`
                    );
                  });

                this.fieldTicketForm.push({
                  name: input.name,
                  type: input.type,
                  web: input.web,
                  collection: collectionData,
                  label: input.label != undefined ? input.label : undefined,
                });
              } else {
                this.fieldTicketForm.push({
                  name: input.name,
                  type: input.type,
                  web: input.web,

                  label: input.label != undefined ? input.label : undefined,
                });
              }
              const fieldObj = {
                  key: input.name.toLowerCase(),
                  label: input.label != undefined ? input.label : undefined,
                  sortable: true,
                };
                this.hoursFields.push(fieldObj);

            }
            // find index of hours field to insert type badge beside it
            let hoursFieldIndex = this.hoursFields.findIndex(
              (x) => x.key === 'hours'
            );
            this.hoursFields.splice(hoursFieldIndex + 1, 0, {
              key: 'type',
              label: 'Type',
              sortable: true,
            });
            // doc.data().inputs.forEach(async (input) => {

            // });
            this.hoursFields.push({
              key: 'lineTotal',
              label: 'Line Total',
              sortable: true,
            });
          });
        })
        .catch((err) => {
          console.log(err);
          console.log(`Error getitng field ticket form`);
        });
    },
    generateProductForm: async function () {
      await getProductForm()
        .then((querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            //start creating the form object.
            this.productsFields.push({
              key: 'edit',
              sortable: false,
            });
            this.productsFields.push({
              key: 'approved',
              sortable: true,
            });
            this.productsFields.push({
              key: 'billable',
              label: 'Exclude From Billing',
              sortable: true,
            });
            this.productsFields.push({
              key: 'user',
              sortable: true,
            });
            for (let input of doc.data().inputs) {
              if (input.name == 'Products') {
                this.productForm.push({
                  name: input.name,
                  type: input.type,
                  web: input.web,
                  collection: this.productOptions,
                  label: input.label != undefined ? input.label : undefined,
                  required: input.required,
                });
              } else if (input.type == 'dropdown' && input.name == 'User') {
                this.productForm.push({
                  name: input.name,
                  type: input.type,
                  web: input.web,
                  collection: this.employees,
                  label: input.label != undefined ? input.label : undefined,
                  required: input.required,
                });
              } else if (input.type == 'dropdown') {
                //go get the collection
                let collectionData = [];
                await getCustomCollectionDataFromName(input.collection)
                  .then((collectionSnapshot) => {
                    collectionSnapshot.forEach((collectionItem) => {
                      collectionData = collectionItem.data().values;
                    });
                  })
                  .catch(() => {
                    console.log(
                      `Error getting collection data for dynamic control ${input.name}`
                    );
                  });

                this.productForm.push({
                  name: input.name,
                  type: input.type,
                  web: input.web,
                  collection: collectionData,
                  label: input.label != undefined ? input.label : undefined,
                  required: input.required,
                });
              } else {
                this.productForm.push({
                  name: input.name,
                  type: input.type,
                  web: input.web,
                  label: input.label != undefined ? input.label : undefined,
                  required: input.required,
                });
              }

              if (
                input.name.toLowerCase() !== 'rate' &&
                input.name.toLowerCase() !== 'price'
              ) {
                this.productsFields.push({
                  key: input.name.toLowerCase(),
                  label: input.label != undefined ? input.label : undefined,
                  sortable: true,
                });
              }
            }
            this.productsFields.push({
              key: 'price',
              label: 'Purchase Price',
              sortable: true,
            });
            this.productsFields.push({
              key: 'rate',
              label: 'Billable Rate',
              sortable: true,
            });
            this.productsFields.push({
              key: 'lineTotal',
              label: 'Line Total',
              sortable: true,
            });
          });
        })
        .catch((err) => {
          console.log(err);
          console.log(`Error getitng field ticket form`);
        });
    },
    updateRate: async function (
      rate,
      overtimeRate,
      travelTimeRate,
      user,
      noRatesFetched
    ) {
      // If addTimeModal is true that means we need to apply this update rate logic to the fieldTicketForm fields as opposed to fieldTicketFormEdit fields
      if (this.addTimeModal) {
        this.editTime_selectedEmployee = { name: user.name, uid: user.uid };
        //get user's specific job rate to be used if it exists
        let jobSpecificIndex = this.currentEmployees.findIndex(
          (x) => x.uid === user.uid
        );
        // go through modals current fields and find index's for ot rate, travel rate, and rate
        let refRateIndex = this.$refs.fieldTicketFormFields.findIndex(
          (x) => x.field.name === 'Rate'
        );
        let refOtRateIndex = this.$refs.fieldTicketFormFields.findIndex(
          (x) => x.field.name === 'Overtime Rate'
        );
        let refTravelRateIndex = this.$refs.fieldTicketFormFields.findIndex(
          (x) => x.field.name === 'Travel Rate'
        );
        // update modal values to show visual changes to user
        if (jobSpecificIndex === -1) {
          this.$refs.fieldTicketFormFields[refRateIndex].value = rate;
          this.$refs.fieldTicketFormFields[refOtRateIndex].value = overtimeRate;
          this.$refs.fieldTicketFormFields[refTravelRateIndex].value =
            travelTimeRate;
        } else {
          this.$refs.fieldTicketFormFields[refRateIndex].value =
            this.currentEmployees[jobSpecificIndex].rate;
          this.$refs.fieldTicketFormFields[refOtRateIndex].value =
            this.currentEmployees[jobSpecificIndex].overtimeRate;
          this.$refs.fieldTicketFormFields[refTravelRateIndex].value =
            this.currentEmployees[jobSpecificIndex].travelRate;
        }
      } else {
        // if noRatesFetched is true that means we called updateRate directly from this component's hour type change select
        if (noRatesFetched) {
          // get rates
          try {
            await getEmployeesRate(this.editTime_selectedEmployee.name)
              .then((response) => {
                response.forEach((doc) => {
                  (rate = doc.data().rate),
                    (overtimeRate = doc.data().overtimeRate),
                    (travelTimeRate = doc.data().travelTimeRate),
                    (user = {
                      uid: doc.data().auth,
                      name: this.editTime_selectedEmployee.name,
                    });
                });
              })
              .catch((err) => {
                console.log(`Error getting employee's rates: ${err}`);
                Swal.fire('Error!', 'Error getting employees rates.', 'error');
              });
          } catch (err) {
            console.log(`Error setting employee's rate data: ${err}`);
            Swal.fire('Error!', 'Error setting employees rate data.', 'error');
          }
        }

        this.editTime_selectedEmployee = { name: user.name, uid: user.uid };
        let refOtIndex;
        let refTravelIndex;
        let refHoursIndex;
        // //find the control that is for each rate, and update the value assigned to it.
        // get indexes for dynamic form fields
        let refRateIndex = this.$refs.fieldTicketFormFields.findIndex(
          (x) => x.field.name === 'Rate'
        );
        //get user's specific job rate to be used if it exists after all the hour indexes are set
        let jobSpecificIndex = this.currentEmployees.findIndex(
          (x) => x.uid === user.uid
        );

        // if overtime hours checked, go through modals current fields and find index to the field for the hours
        if (this.editTimeHourType === 'overtime') {
          if (
            this.fieldTicketFormEdit.findIndex((x) => x.label === 'Hours') !==
            -1
          ) {
            refOtIndex = this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Hours'
            );
          } else if (
            this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Overtime Hours'
            ) !== -1
          ) {
            refOtIndex = this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Overtime Hours'
            );
          } else if (
            this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Travel Time Hours'
            ) !== -1
          ) {
            refOtIndex = this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Travel Time Hours'
            );
          }
          if (jobSpecificIndex === -1) {
            // update modal values to show visual changes to user
            this.$refs.fieldTicketFormFields[refRateIndex].value = overtimeRate;

            // replace the modals current hours field with a new one with appropiate label
            this.fieldTicketFormEdit.splice(refOtIndex, 1, {
              name: 'Hours',
              label: 'Overtime Hours',
              web: true,
              type: 'number',
            });
          }
        } else if (this.editTimeHourType === 'travel') {
          if (
            this.fieldTicketFormEdit.findIndex((x) => x.label === 'Hours') !==
            -1
          ) {
            refTravelIndex = this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Hours'
            );
          } else if (
            this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Overtime Hours'
            ) !== -1
          ) {
            refTravelIndex = this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Overtime Hours'
            );
          } else if (
            this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Travel Time Hours'
            ) !== -1
          ) {
            refTravelIndex = this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Travel Time Hours'
            );
          }
          if (jobSpecificIndex === -1) {
            // update modal values to show visual changes to user
            this.$refs.fieldTicketFormFields[refRateIndex].value =
              travelTimeRate;

            // replace the modals current hours field with a new one with appropiate label
            this.fieldTicketFormEdit.splice(refTravelIndex, 1, {
              name: 'Hours',
              label: 'Travel Time Hours',
              web: true,
              type: 'number',
            });
          }
        } else if (this.editTimeHourType === 'regular') {
          if (
            this.fieldTicketFormEdit.findIndex((x) => x.label === 'Hours') !==
            -1
          ) {
            refHoursIndex = this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Hours'
            );
          } else if (
            this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Overtime Hours'
            ) !== -1
          ) {
            refHoursIndex = this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Overtime Hours'
            );
          } else if (
            this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Travel Time Hours'
            ) !== -1
          ) {
            refHoursIndex = this.fieldTicketFormEdit.findIndex(
              (x) => x.label === 'Travel Time Hours'
            );
          }
          if (jobSpecificIndex === -1) {
            // update modal values to show visual changes to user
            this.$refs.fieldTicketFormFields[refRateIndex].value = rate;

            // replace the modals current hours field with a new one with appropiate label
            this.fieldTicketFormEdit.splice(refHoursIndex, 1, {
              name: 'Hours',
              label: 'Hours',
              web: true,
              type: 'number',
            });
          }
        }
        // if the jobspecific index exists for this user then set their modal rate value to the specific ot, reg, or travel value
        if (jobSpecificIndex !== -1) {
          // update modal values to show visual changes to user
          if (refHoursIndex !== -1 && refHoursIndex !== undefined) {
            this.$refs.fieldTicketFormFields[refRateIndex].value =
              this.currentEmployees[jobSpecificIndex].rate;

            // replace the modals current hours field with a new one with appropiate label
            this.fieldTicketFormEdit.splice(refHoursIndex, 1, {
              name: 'Hours',
              label: 'Hours',
              web: true,
              type: 'number',
            });
          }
          if (refOtIndex !== -1 && refOtIndex !== undefined) {
            this.$refs.fieldTicketFormFields[refRateIndex].value =
              this.currentEmployees[jobSpecificIndex].overtimeRate;

            // replace the modals current hours field with a new one with appropiate label
            this.fieldTicketFormEdit.splice(refOtIndex, 1, {
              name: 'Hours',
              label: 'Overtime Hours',
              web: true,
              type: 'number',
            });
          }
          if (refTravelIndex !== -1 && refTravelIndex !== undefined) {
            this.$refs.fieldTicketFormFields[refRateIndex].value =
              this.currentEmployees[jobSpecificIndex].travelRate;

            // replace the modals current hours field with a new one with appropiate label
            this.fieldTicketFormEdit.splice(refTravelIndex, 1, {
              name: 'Hours',
              label: 'Travel Time Hours',
              web: true,
              type: 'number',
            });
          }
        }
      }
    },
    updateProductRate(rate, id, price) {
      //find the control that is for the rate, and update the value assigned to it.
      let i = this.$refs.productFormFields.findIndex(
        (o) => o.field.name == 'Rate'
      );

      let j = this.$refs.productFormFields.findIndex(
        (o) => o.field.name == 'Price'
      );

      let index = this.currentProducts.findIndex((o) => o.uid == id);
      if (index !== -1) {
        this.$refs.productFormFields[i].value =
          this.currentProducts[index].rate;
        this.$refs.productFormFields[j].value =
          this.currentProducts[index].price;
      } else {
        this.$refs.productFormFields[i].value = rate;

        this.$refs.productFormFields[j].value = price;
      }
    },
    getTimes: async function () {
      //get the chargeable time for the job
      await firestore()
        .collection('times')
        .where('jobNum', '==', Number(this.jobNum))
        .where('org', '==', sessionStorage.getItem('org'))
        .orderBy('date', 'asc')
        .get()
        .then((timesSnapShot) => {
          timesSnapShot.forEach((time) => {
            let timeObj = {};
            timeObj.edit = time.id;
            timeObj.approved = time.data().approved;
            timeObj.approvedBy = time.data().approvedBy;
            timeObj.approvedTime = time.data().approvedTime;
            timeObj.billable = time.data().billable;
            timeObj.billableApprovedBy = time.data().billableApprovedBy;
            timeObj.billableApprovedTime = time.data().billableApprovedTime;
            timeObj.uid = time.data().user;
            timeObj.overtime = time.data().overtime
              ? time.data().overtime
              : false;
            timeObj.travelTime = time.data().travelTime
              ? time.data().travelTime
              : false;
            timeObj.type = timeObj.overtime
              ? 'ot'
              : timeObj.travelTime
              ? 'tt'
              : 'reg';
            //loop through the dynamic fields and get the values.
            this.fieldTicketForm.forEach((field) => {
              if (field.type == 'dateTime') {
                timeObj[`${field.name.toLowerCase()}`] =
                  time.data()[field.name.toLowerCase()] == undefined
                    ? undefined
                    : moment(
                        time.data()[field.name.toLowerCase()].toDate()
                      ).format('MMM DD, YY');
              } else if (field.type == 'rate') {
                timeObj[`${field.name.toLowerCase()}`] =
                  time.data()[field.name.toLowerCase()] == undefined
                    ? undefined
                    : time.data()[field.name.toLowerCase()];
              } else {
                timeObj[`${field.name.toLowerCase()}`] =
                  time.data()[field.name.toLowerCase()] == undefined
                    ? undefined
                    : time.data()[field.name.toLowerCase()];
              }
            });

            //add the line total.
            timeObj.lineTotal =
              timeObj.rate != undefined
                ? (Number(timeObj.rate) * Number(timeObj.hours)).toFixed(2)
                : 0;

            this.hoursTableData.push(timeObj);
          });
          this.hoursTotalRows = timesSnapShot.size;
          this.timesLoaded = true;
        })
        .catch((err) => {
          console.log(`Error getting times ${err}`);
        });
    },
    getBillableProducts: async function () {
      //get the chargeable product for the job
      await firestore()
        .collection('billableProducts')
        .where('jobNum', '==', Number(this.jobNum))
        .where('org', '==', sessionStorage.getItem('org'))
        .orderBy('date', 'asc')
        .get()
        .then((productSnapShot) => {
          productSnapShot.forEach((product) => {
            let productObj = {};
            productObj.edit = product.id;
            productObj.approved = product.data().approved;
            productObj.approvedBy = product.data().approvedBy;
            productObj.approvedTime = product.data().approvedTime;
            productObj.billable = product.data().billable;
            productObj.billableApprovedBy = product.data().billableApprovedBy;
            productObj.billableApprovedTime =
              product.data().billableApprovedTime;
            productObj.user = product.data()['user'].name;
            //loop through the dynamic fields and get the values.
            this.productForm.forEach((field) => {
              if (field.type == 'dateTime') {
                productObj[`${field.name.toLowerCase()}`] =
                  product.data()[field.name.toLowerCase()] == undefined
                    ? undefined
                    : moment(
                        product.data()[field.name.toLowerCase()].toDate()
                      ).format('MMM DD, YY');
              } else if (field.type == 'rate') {
                productObj[`${field.name.toLowerCase()}`] =
                  product.data()[field.name.toLowerCase()] == undefined
                    ? undefined
                    : product.data()[field.name.toLowerCase()];
              } else {
                productObj[`${field.name.toLowerCase()}`] =
                  product.data()[field.name.toLowerCase()] == undefined
                    ? undefined
                    : product.data()[field.name.toLowerCase()];
              }
            });

            //add the line total.
            productObj.lineTotal =
              productObj.rate != undefined
                ? (
                    Number(productObj.rate) * Number(productObj.quantity)
                  ).toFixed(2)
                : 0;

            this.productsTableData.push(productObj);
          });
          this.productTotalRows = productSnapShot.size;
          this.productsLoaded = true;
        })
        .catch((err) => {
          console.log(`Error getting products ${err}`);
        });
    },
    onFileAdded: async function (file) {
      let success = await uploadFile(file, this.jobNum);
      if (success[0] == true) {
        this.jobFiles.push(success[3]);

        this.$refs.fileUploader.removeFile(file);
        Vue.$toast.open({
          message: 'Document uploaded successfully',
          type: 'success',
          duration: 4000,
          position: 'top-right',
        });
      } else {
        Swal.fire('Error!', 'Error uploading file.', 'error');
      }
    },
    onDownloadFile: async function (fileName) {
      let downloadURL = await downloadFile(fileName, this.jobNum);
      axios
        .get(downloadURL, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = this.formattedFileName(fileName);
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(() => {
          Vue.$toast.open({
            message: 'Error downloading document',
            type: 'error',
            duration: 4000,
            position: 'top-right',
          });
        });
    },
    onDeleteFile: function (fileName, id, fileSize) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This file will be deleted permanently',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
      }).then(async (result) => {
        if (result.value) {
          let success = await deleteFile(
            fileName,
            this.jobNum,
            false,
            id,
            fileSize
          );
          if (success) {
            //remove the file from the lsit.
            let index = this.jobFiles.findIndex((o) => o.fileName == fileName);
            this.jobFiles.splice(index, 1);
            Vue.$toast.open({
              message: 'Document successfully deleted',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          } else {
            Swal.fire('Error!', 'Error deleting file.', 'error');
          }
        }
      });
    },
    getJobDetails: function () {
      firestore()
        .collection('jobs')
        .where('jobNum', '==', Number(this.$route.params.id))
        .where('org', '==', sessionStorage.getItem('org'))
        .get()
        .then(async (jobQuerySnapshot) => {
          jobQuerySnapshot.forEach((job) => {
            this.jobID = job.id;
            this.jobNum = job.data().jobNum;
            this.jobCustomer = job.data().customerDisplayName;
            this.jobDate = moment(job.data().date.toDate()).format(
              'MMM DD, YY'
            );
            this.supervisor = job.data().supervisor
              ? job.data().supervisor
              : null;
            this.jobType = job.data().jobType ? job.data().jobType : null;
            this.jobQuote = job.data().jobQuote ? job.data().jobQuote : null;
            this.jobDesc = job.data().description;
            this.controls = job.data().controls ? job.data().controls : null;
            this.jobRevenueCalculations = job.data().jobRevenueCalculations
              ? job.data().jobRevenueCalculations
              : 'default';
            this.procurementControls = job.data().procurementControls
              ? job.data().procurementControls
              : null;
            this.jobBudget = job.data().jobBudget ? job.data().jobBudget : null;
            this.approvedStatus = job.data().approvedStatus
              ? job.data().approvedStatus
              : { times: 0, products: 0, files: 0 };

            this.jobComplete = job.data().completed
              ? job.data().completed
              : false;
            this.budgetRevisions = job.data().budgetRevisions
              ? job.data().budgetRevisions
              : [];
            this.invoiceHistory = job.data().invoices
              ? job.data().invoices
              : [];
            this.jobDepartment = job.data().jobDepartment ? job.data().jobDepartment : null;
            this.futureTimesEnabled = job.data().futureTimesEnabled ? job.data().futureTimesEnabled : false;
            let flag = false;
            if (this.jobBudget) {
              flag = true;
            }

            //if we have controls for the job, format the edited controls, so we can edit them
            if (this.controls) {
              //sort the controls objects, so they are in alphabetical order.
              this.controls = Object.keys(this.controls)
                .sort()
                .reduce((obj, key) => {
                  obj[key] = this.controls[key];
                  return obj;
                }, {});
              // new object and not a reference to the old one
              this.editedControls = JSON.parse(JSON.stringify(this.controls));

              //sort the controls objects, so they are in alphabetical order.
              this.editedControls = Object.keys(this.editedControls)
                .sort()
                .reduce((obj, key) => {
                  obj[key] = this.editedControls[key];
                  return obj;
                }, {});

              //set the types for each control.
              for (let control in this.editedControls) {
                this.editedControls[control].types = ['Dollar Amount'];
                if (this.editedControls[control].name == 'Labour') {
                  this.editedControls[control].unitOfMeasures = [
                    'Billable Rate',
                    'Payroll Rate',
                  ];
                } else if (this.editedControls[control].name == 'Products') {
                  this.editedControls[control].unitOfMeasures = [
                    'Dollar Amount',
                  ];
                } else if (
                  this.editedControls[control].name == 'Procurements'
                ) {
                  this.editedControls[control].unitOfMeasures = [
                    'Marked-up Amount',
                    'Received Amount',
                  ];
                }
              }

              for (const control in this.controls) {
                let data = this.controls[control];
                for (const key in data) {
                  if (key === 'active' && data[key] === true) {
                    flag = true;
                  }
                }
              }
            }

            if (this.procurementControls) {
              //sort the controls objects, so they are in alphabetical order.
              this.procurementControls = Object.keys(this.procurementControls)
                .sort()
                .reduce((obj, key) => {
                  obj[key] = this.procurementControls[key];
                  return obj;
                }, {});
              // new object and not a reference to the old one
              this.editedProcurementControls = JSON.parse(
                JSON.stringify(this.procurementControls)
              );

              //sort the controls objects, so they are in alphabetical order.
              this.editedProcurementControls = Object.keys(
                this.editedProcurementControls
              )
                .sort()
                .reduce((obj, key) => {
                  obj[key] = this.editedProcurementControls[key];
                  return obj;
                }, {});

              //set the types for each control.
              for (let control in this.editedProcurementControls) {
                this.editedProcurementControls[control].types = [
                  'Dollar Amount',
                ];
                this.editedProcurementControls[control].unitOfMeasures = [
                  'Marked-up Amount',
                  'Received Amount',
                ];
              }

              for (const control in this.procurementControls) {
                let data = this.procurementControls[control];
                for (const key in data) {
                  if (key === 'active' && data[key] === true) {
                    flag = true;
                  }
                }
              }
            }

            if (this.invoiceHistory) {
              //if therer is invoice history, then we need to itterate it, format the dates, and add the edit field to the array.
              this.invoiceHistory.forEach((invoice) => {
                invoice.date = moment
                  .unix(invoice.date.seconds)
                  .format('MMM DD, yy');
                invoice.edit = (Math.random() + 1).toString(36).substring(7); //this is a randomly generated value, so each invoice has a unique identifier in the child component.
              });
            }

            this.controlsEnabled = flag;
            this.editedControlsEnabled = flag;
          });
          //after we have retreived the job id, then we will get the files for the job.
          this.jobFiles = await getFilesForJob(this.jobNum);
          this.generateSafetyFormTable();
        })

        .catch((err) => {
          console.log(`Error getting job data: ${err}`);
          Swal.fire('Error!', `Error getting job data: ${err}`, 'error');
        });
    },
    getInitialSafetyForms: function () {
      getSafetyForms()
        .then((response) => {
          if (!response.empty) {
            response.forEach((form) => {
              this.safetyForms.push({
                name: form.data().displayName,
                id: form.id,
              });
            });
          }
        })
        .catch((err) => {
          Swal.fire(
            'Error!',
            `Error getting list of safety forms: ${err}`,
            'error'
          );
        });
    },
    showSignOffs: function () {
      this.hideSignOffs = !this.hideSignOffs;
    },
    showRevisionSelection: function () {
      this.hideRevisionSelection = !this.hideRevisionSelection;
    },
    showRevisionDetail: function (index) {
      //loop over the revisions and set the selected revision as shown and set the rest to hidden.
      for (let i = 0; i <= this.safetyFormDetail.revisions.length - 1; i++) {
        if (i == index) {
          let placeHolder = this.safetyFormDetail.revisions[i];
          placeHolder.shown = true;
          //we are splicing here, because the reactivity wasn't working with just setting the boolean value in the array. Vue thangs.
          this.safetyFormDetail.revisions.splice(i, 1, placeHolder);
          // this.safetyFormDetail.revisions[i].shown = true;
        } else {
          let placeHolder = this.safetyFormDetail.revisions[i];
          placeHolder.shown = false;
          this.safetyFormDetail.revisions.splice(i, 1, placeHolder);
        }
      }
    },
    getJobRates: function () {
      firestore()
        .collection('jobs')
        .where('jobNum', '==', Number(this.$route.params.id))
        .where('org', '==', sessionStorage.getItem('org'))
        .get()
        .then((employeeSnapshot) => {
          employeeSnapshot.forEach((eData) => {
            //check to see if there any dispatched rates for this job.
            if (eData.data().specifiedRates != undefined) {
              //there are job rates.
              //loop the rates and push the data to currentEmployees
              Object.keys(eData.data().specifiedRates).forEach((uid) => {
                let index = this.employees.findIndex((o) => o.uid == uid);
                if (index >= 0) {
                  this.currentEmployees.push({
                    uid: this.employees[index].uid,
                    name: this.employees[index].name,
                    rate: eData.data().specifiedRates[uid].regular,
                    overtimeRate: eData.data().specifiedRates[uid].overtime,
                    travelRate: eData.data().specifiedRates[uid].travel,
                  });
                }
              });
            }
            if (eData.data().specifiedProductRates != undefined) {
              //there are job product rates.
              //loop the rates and push the data to currentProducts
              Object.keys(eData.data().specifiedProductRates).forEach((uid) => {
                let index = this.products.findIndex((o) => o.uid == uid);
                if (index >= 0) {
                  this.currentProducts.push({
                    uid: this.products[index].uid,
                    name: this.products[index].name,
                    rate: eData.data().specifiedProductRates[uid].rate,
                    price: eData.data().specifiedProductRates[uid].price,
                  });
                }
              });
            }
          });
        })
        .catch((err) => {
          console.log(`Error getting employee info: ${err}`);
          Swal.fire(
            'Error!',
            `An error was encountered when gathering user data. ${err}`,
            'error'
          );
        });
    },
    validateAddRate: function () {
      try {
        //check if an employee is selected.
        let flag = true;
        let retObj = {};

        this.$refs.fieldTicketFormFields.forEach((field) => {
          if (field.field.web === true) {
            if (
              field.value === null ||
              field.value === undefined ||
              field.value.toString().trim() == ''
            ) {
              field.hasError = true;
              field.errorMessage = 'Value cannot be empty.';
              flag = false;
            } else {
              field.hasError = false;
              field.errorMessage = null;
              retObj[field.field.name.toLowerCase()] = field.value;
            }
            if (field.field.type === 'number' && flag === true) {
              if (isNaN(field.value.toString().trim())) {
                field.hasError = true;
                field.errorMessage = 'Value is not a decimal.';
                flag = false;
              }
            }
          }
        });

        //if the form is valid, then we send back the form in an object to be inserted.
        if (flag) {
          return retObj;
        } else {
          return flag;
        }
      } catch (err) {
        console.log(err);
      }
    },
    approveTime: async function (value, id) {
      try {
        let db = firebase.firestore();
        let page = db.collection('times').doc(id);
        let user = JSON.parse(sessionStorage.authUser);
        let approvedTime = Date.now();

        let index = this.hoursTableData.findIndex((data) => data.edit === id);
        let newData = JSON.parse(JSON.stringify(this.hoursTableData[index]));
        newData.approved = value;
        newData.approvedTime = value ? Date(approvedTime) : null;
        newData.approvedBy = value
          ? { name: user.displayName, uid: user.uid }
          : null;

        await page
          .update({
            approved: newData.approved,
            approvedTime: newData.approvedTime,
            approvedBy: newData.approvedBy,
          })
          .then(() => {
            this.hoursTableData.splice(index, 1, newData);
            Vue.$toast.open({
              message: value
                ? 'Time approved successfully'
                : 'Time unapproved successfully',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          })
          .catch(() => {
            console.log(`Error changing time approval status.`);
            Swal.fire(
              'Error!',
              'An error was encountered when changing the times approval status',
              'error'
            );
          });
      } catch (error) {
        console.log(error);
        Swal.fire('Error!', 'An error was encountered', 'error');
      }
    },

    approveProduct: async function (value, id) {
      try {
        let db = firebase.firestore();
        let page = db.collection('billableProducts').doc(id);
        let user = JSON.parse(sessionStorage.authUser);
        let approvedTime = Date.now();

        let index = this.productsTableData.findIndex(
          (data) => data.edit === id
        );
        let newData = JSON.parse(JSON.stringify(this.productsTableData[index]));
        newData.approved = value;
        newData.approvedTime = value ? Date(approvedTime) : null;
        newData.approvedBy = value
          ? { name: user.displayName, uid: user.uid }
          : null;
        await page
          .update({
            approved: newData.approved,
            approvedTime: newData.approvedTime,
            approvedBy: newData.approvedBy,
          })
          .then(() => {
            this.productsTableData.splice(index, 1, newData);
            Vue.$toast.open({
              message: value
                ? 'Product approved successfully'
                : 'Product unapproved successfully',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          })
          .catch(() => {
            console.log(`Error changing product approval status.`);
            Swal.fire(
              'Error!',
              'An error was encountered when changing the products approval status',
              'error'
            );
          });
      } catch (error) {
        console.log(error);
        Swal.fire('Error!', 'An error was encountered', 'error');
      }
    },
    updateTimeBillable: async function (value, id) {
      try {
        let db = firebase.firestore();
        let page = db.collection('times').doc(id);
        let user = JSON.parse(sessionStorage.authUser);
        let approvedTime = Date.now();

        let index = this.hoursTableData.findIndex((data) => data.edit === id);
        let newData = JSON.parse(JSON.stringify(this.hoursTableData[index]));
        newData.billable = value;
        newData.billableApprovedTime = value ? Date(approvedTime) : null;
        newData.billableApprovedBy = value
          ? { name: user.displayName, uid: user.uid }
          : null;
        await page
          .update({
            billable: newData.billable,
            billableApprovedTime: newData.billableApprovedTime,
            billableApprovedBy: newData.billableApprovedBy,
          })
          .then(() => {
            this.hoursTableData.splice(index, 1, newData);
            Vue.$toast.open({
              message: value
                ? 'Time excluded from billing successfully'
                : 'Time included in billing successfully',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          })
          .catch(() => {
            console.log(`Error changing time billable approval status.`);
            Swal.fire(
              'Error!',
              'An error was encountered when changing the times billable approval status',
              'error'
            );
          });
      } catch (error) {
        console.log(error);
        Swal.fire('Error!', 'An error was encountered', 'error');
      }
    },
    updateProductBillable: async function (value, id) {
      try {
        let db = firebase.firestore();
        let page = db.collection('billableProducts').doc(id);
        let user = JSON.parse(sessionStorage.authUser);
        let approvedTime = Date.now();

        let index = this.productsTableData.findIndex(
          (data) => data.edit === id
        );
        let newData = JSON.parse(JSON.stringify(this.productsTableData[index]));
        newData.billable = value;
        newData.billableApprovedTime = value ? Date(approvedTime) : null;
        newData.billableApprovedBy = value
          ? { name: user.displayName, uid: user.uid }
          : null;
        await page
          .update({
            billable: newData.billable,
            billableApprovedTime: newData.billableApprovedTime,
            billableApprovedBy: newData.billableApprovedBy,
          })
          .then(() => {
            this.productsTableData.splice(index, 1, newData);
            Vue.$toast.open({
              message: value
                ? 'Product excluded from billing successfully'
                : 'Product included in billing successfully',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          })
          .catch(() => {
            console.log(`Error changing product billable approval status.`);
            Swal.fire(
              'Error!',
              'An error was encountered when changing the products billable approval status',
              'error'
            );
          });
      } catch (error) {
        console.log(error);
        Swal.fire('Error!', 'An error was encountered', 'error');
      }
    },
    getProducts() {
      firestore()
        .collection('products')
        .where('org', '==', sessionStorage.org)
        .get()
        .then((productSnapshot) => {
          productSnapshot.forEach((doc) => {
            this.products.push({
              uid: doc.id,
              name: doc.data().displayName,
              rate: doc.data().defaultRate,
              price: doc.data().price ? doc.data().price : null,
            });
            this.productOptions.push(doc.data().displayName);
          });
        });
    },
    setTableSettings: function () {
      if (this.currentUser.tablePageLengths) {
        if (this.currentUser.tablePageLengths.perPage_jobDetsHours) {
          this.hoursPerPage =
            this.currentUser.tablePageLengths.perPage_jobDetsHours;
        }
        if (this.currentUser.tablePageLengths.perPage_jobDetsProducts) {
          this.productsPerPage =
            this.currentUser.tablePageLengths.perPage_jobDetsProducts;
        }
        if (this.currentUser.tablePageLengths.perPage_jobDetsSafetyForms) {
          this.perPage =
            this.currentUser.tablePageLengths.perPage_jobDetsSafetyForms;
        }
      }
    },
    reviewDocument: async function (value, id) {
      try {
        let page = firestore().collection('jobDocuments').doc(id);
        if (value) {
            let reviewed = true;
            let reviewedTime = Date(Date.now())
            let reviewedBy = { name: this.currentUser.displayName, uid: this.currentUser.auth }
          await page.update({
            reviewed: reviewed,
              reviewedTime: reviewedTime,
              reviewedBy: reviewedBy,
          });

          let index = this.jobFiles.findIndex((data) => data.id === id);
          this.jobFiles[index].reviewed = reviewed;
          this.jobFiles[index].reviewedTime = reviewedTime
          this.jobFiles[index].reviewedBy = reviewedBy


          Vue.$toast.open({
            message: 'Document marked as reviewed',
            type: 'success',
            duration: 4000,
            position: 'top-right',
          });
        } else {
          await page.update({
            reviewed: false,
            reviewedTime: null,
            reviewedBy: null,
          });

          let index = this.jobFiles.findIndex((data) => data.id === id);
          this.jobFiles[index].reviewed = false;
          this.jobFiles[index].reviewedBy = null
          this.jobFiles[index].reviewedTime = null

          Vue.$toast.open({
            message: 'Document marked as unreviewed',
            type: 'success',
            duration: 4000,
            position: 'top-right',
          });
        }
      } catch (error) {
        console.log(error);
        Swal.fire('Error!', 'An error was encountered when updating document review status', 'error');
      }
    },
    getDocumentReviewDetails: function (document){
        return document.reviewed && document.reviewedBy && document.reviewedTime ?
                      `Reviewed by ${document.reviewedBy.name} on ${moment(document.reviewedTime).format('MMM DD, YYYY [at] h:mm A')}` :
                      ''
    },
    sizeInBytes: function (fileSize) {
      return bytesToSize(fileSize);
    },
    formattedFileName: function (fileName) {
      return fileName.substring(fileName.indexOf('-') + 1);
    },
    momentDateFormat: function (date) {
      return moment(date).format('MMM DD, yy');
    },
    bulkDeleteFiles: function () {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This file will be deleted permanently',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
      }).then(async (result) => {
        if (result.value) {
          let storage = firebase.storage();
          let selectedFiles = this.jobFiles.filter((o) => o.selected);
          let batchSize = 0;

          // Get a new write batch
          var batch = firestore().batch();

          //loop the selected documents and add them to the delete batch.
          for (const file of selectedFiles) {
            //get the document reference.
            var ref = firestore().collection('jobDocuments').doc(file.id);
            //add the reference to the batch.
            batch.delete(ref);

            //sum the total file sizes
            batchSize = Number(batchSize) + Number(file.fileSize);
          }

          // Commit the batch
          batch
            .commit()
            .then(async () => {
              //loop the files again and remove them from cloud storage.
              for (const file of selectedFiles) {
                //remove the document from clopud storage.
                await storage
                  .ref(
                    `${sessionStorage.getItem('org')}/jobDocuments/${
                      this.jobNum
                    }/${file.fileName}`
                  )
                  .delete()
                  .then(() => {
                    //remove the file from the array as well, so it is no longer in the table.
                    let index = this.jobFiles.findIndex(
                      (o) => o.fileName == file.fileName
                    );
                    this.jobFiles.splice(index, 1);
                  });
              }

              //update the cloud storage billing.
              // updateStorageBilling(batchSize * -1);

              Vue.$toast.open({
                message: 'Files successfully deleted.',
                type: 'success',
                duration: 4000,
                position: 'top-right',
              });
            })
            .catch((err) => {
              console.log(err);
              Vue.$toast.open({
                message: 'Error deleting document.',
                type: 'error',
                duration: 4000,
                position: 'top-right',
              });
            });
        }
      });
    },
    emailFiles: function (bvModalEvt) {
      //check to make sure the email address is valid.
      if (this.fileEmailAddressInputValid) {
        //get the selected files.
        let user = JSON.parse(sessionStorage.authUser);
        let selectedFiles = this.jobFiles.filter((o) => o.selected);
        let selectedIDs = [];
        //grab all of the doc ids and send by email.
        selectedFiles.forEach((file) => {
          selectedIDs.push(file.id);
        });

        let request = {
          files: selectedIDs,
          email: this.fileEmailAddress,
          senderName: user.displayName,
        };
        axios
          .get(
            'https://us-central1-kali-45420.cloudfunctions.net/sendJobDocumentsReport',
            {
              params: {
                request,
              },
            }
          )
          .then((response) => {
            if (response.status == 200) {
              //the request was successful.
              Vue.$toast.open({
                message: 'Email report sent',
                type: 'success',
                duration: 4000,
                position: 'top-right',
              });
            }
          })
          .catch((err) => {
            console.log(err);
            Vue.$toast.open({
              message: 'Error sending email.',
              type: 'error',
              duration: 4000,
              position: 'top-right',
            });
          });
      } else {
        this.submitEmailErrorMessage = true;
        bvModalEvt.preventDefault(); //prevent the modal from closing.
      }
    },
    changeValidationValue: function (field, value) {
      if (field === 'fileEmailAddress') {
        this.fileEmailAddressInputValid = value;
      }
    },
    revenueCalculated: function (revenueSummary, totalRevenue) {
      //revenue will count to labour budget if labour is set to billable rate and the type is dollar amount
      //revenue will always count to products budget
      //revenue will cound to procurement items budget if the unit of measure is set to marked-up amount.
      this.revenueSummary = revenueSummary;
      this.totalRevenue = totalRevenue;
      this.applyRevenueBudget();
    },
    expensesCalculated: function (expensesSummary, totalExpenses) {
      //expenses will count to labour budget if labour is set to payroll rate and the type is dollar amount
      //expenses will cound to procurement items budget if the unit of measure is set to received amount.
      this.expensesSummary = expensesSummary;
      this.totalExpenses = totalExpenses;
      this.applyExpensesBudget();
    },
    applyRevenueBudget: function () {
      //take the total and apply them to the budget, if there are budgets.
      if (this.controls) {
        for (const control in this.controls) {
          if (
            this.controls[control].unitOfMeasure == 'Billable Rate' &&
            this.controls[control].type == 'Dollar Amount'
          ) {
            this.controls[control].current = this.revenueSummary[control];
          }
        }
      }
      if (this.procurementControls) {
        //loop the procurements and see which ones have the marked-up amount as the unit of measure.
        for (const control in this.procurementControls) {
          // if (
          //   this.procurementControls[control].unitOfMeasure ==
          //   'Marked-up Amount'
          // ) {

          // }
          this.procurementControls[control].current == undefined
            ? (this.procurementControls[control].current = {})
            : null;
          this.procurementControls[control].current['Marked-up Amount'] =
            this.revenueSummary.procurements[
              this.procurementControls[control].name
            ];
        }
      }
    },
    applyExpensesBudget: function () {
      if (this.controls) {
        for (const control in this.controls) {
          // if (control === 'products') {
          //   this.controls[control].current = this.expensesSummary[control];
          // } else
          if (
            this.controls[control].unitOfMeasure == 'Payroll Rate' &&
            this.controls[control].type == 'Dollar Amount'
          ) {
            this.controls[control].current = this.expensesSummary[control];
          }
        }
      }

      if (this.procurementControls) {
        //loop the procurements and see which ones have the marked-up amount as the unit of measure.
        for (const control in this.procurementControls) {
          // if (
          //   this.procurementControls[control].unitOfMeasure == 'Received Amount'
          // ) {

          // }
          this.procurementControls[control].current == undefined
            ? (this.procurementControls[control].current = {})
            : null;
          this.procurementControls[control].current['Received Amount'] =
            this.expensesSummary.procurements[
              this.procurementControls[control].name
            ];
        }
      }
    },
    jobBudgetUpdated(value) {
      this.jobBudget = value;
    },
    tableSort: tableSort,
    completeJob: function (element) {
      //update the complete status of the job.
      try {
        firestore()
          .collection('jobs')
          .doc(this.jobID)
          .update({
            completed: !this.jobComplete,
          })
          .then(() => {
            if (element == 'dropdown') {
              this.jobComplete = !this.jobComplete;
            }
            Vue.$toast.open({
              message: 'Job status updated',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          })
          .catch(() => {
            Swal.fire(
              'Error!',
              'Error updating the competed status of the job.',
              'error'
            );
          });
      } catch (err) {
        Swal.fire(
          'Error!',
          'Error updating the competed status of the job.',
          'error'
        );
      }
    },
    migrateDocuments: async function () {
      //get all of the documents.
      let storage = firebase.storage();
      let files = [];
      let storageRef = storage.ref(
        `${sessionStorage.getItem('org')}/jobDocuments/${this.jobNum}`
      );
      await storageRef
        .list()
        .then(async (res) => {
          for (let file of res.items) {
            let downloadURL;
            let newSR = storage.ref(
              `${sessionStorage.getItem('org')}/jobDocuments/${this.jobNum}/${
                file.name
              }`
            );
            await newSR.getDownloadURL().then((url) => {
              downloadURL = url;
            });
            await file
              .getMetadata()
              .then(async (metadata) => {
                files.push({
                  fileName: metadata.name,
                  fileSize: metadata.size,
                });
                // let momentNow = Date.now();
                await firestore()
                  .collection('jobDocuments')
                  .add({
                    fileName: metadata.name,
                    fileSize: metadata.size,
                    date: new Date(),
                    uploadedBy: {
                      name: 'System',
                      id: 'n/a',
                    },
                    reviewed: false,
                    image: downloadURL,
                    jobNum: this.jobNum,
                    org: sessionStorage.getItem('org'),
                  })
                  .then(async () => {
                    // await updateStorageBilling(Number(metadata.size));
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              })
              .catch((err) => {
                console.log(`Error getting file metadata:`);
                console.log(err);
              });
          }
          // res.items.forEach(async (file) => {

          // });
        })
        .catch((error) => {
          // Uh-oh, an error occurred!

          console.log(error);
        });
      //loop the documents and check to see if the document is in the database. If it isn't then add it.
    },
    formatDates(date) {
      if (date.seconds) {
        return moment(date.toDate()).format('MMM DD, YY HH:mm');
      } else {
        return moment(date).format('MMM DD, YY HH:mm');
      }
    },
    getRevisionString(revision) {
      if (revision.budgetTypeChanged) {
        return `${revision.user.name} changed budget type from  a ${revision.formerBudget} budget to a ${revision.revisedBudget} budget`;
      } else if (revision.category) {
        return `${revision.user.name} ${
          revision.formerBudget >= revision.revisedBudget
            ? 'reduced'
            : 'increased'
        } ${revision.category} budget from $${revision.formerBudget} to $${
          revision.revisedBudget
        }${revision.description ? `: ${revision.description}` : ''}`;
      } else {
        return `${revision.user.name} ${
          revision.formerBudget >= revision.revisedBudget
            ? 'reduced'
            : 'increased'
        } budget from $${revision.formerBudget} to $${revision.revisedBudget}${
          revision.description ? `: ${revision.description}` : ''
        }`;
      }
    },
    async getCompanySettings() {
      let docs = await firebase
        .firestore()
        .collection('organizations')
        .doc(sessionStorage.getItem('org'))
        .collection('settings')
        .get();

      docs.forEach((doc) => {
        this.companySettings = doc.data();
      });

      let index = this.fieldTicketForm.findIndex((x) => x.name === 'Rate');

      if (this.companySettings.mobileTravelTimeField) {
        if (index !== -1) {
          this.fieldTicketForm.splice(index + 1, 0, {
            name: 'travelTime',
            type: 'number',
            web: true,
            label: 'Travel Time Hours',
          });

          this.fieldTicketForm.splice(index + 2, 0, {
            name: 'Travel Rate',
            type: 'number',
            web: true,
            label: 'Travel Time Rate',
          });
        } else {
          this.fieldTicketForm.push({
            name: 'travelTime',
            type: 'number',
            web: true,
            label: 'Travel Time Hours',
          });

          this.fieldTicketForm.push({
            name: 'Travel Rate',
            type: 'number',
            web: true,
            label: 'Travel Time Rate',
          });
        }
      }
      if (this.companySettings.mobileOvertimeField) {
        if (index !== -1) {
          this.fieldTicketForm.splice(index + 1, 0, {
            name: 'overtime',
            type: 'number',
            web: true,
            label: 'Overtime Hours',
          });
          this.fieldTicketForm.splice(index + 2, 0, {
            name: 'Overtime Rate',
            type: 'number',
            web: true,
            label: 'Overtime Rate',
          });
        } else {
          this.fieldTicketForm.push({
            name: 'overtime',
            type: 'number',
            web: true,
            label: 'Overtime Hours',
          });
          this.fieldTicketForm.push({
            name: 'Overtime Rate',
            type: 'number',
            web: true,
            label: 'Overtime Rate',
          });
        }
      }
      this.fieldTicketFormEdit = JSON.parse(
        JSON.stringify(this.fieldTicketForm)
      );
    },
    handleCardHover(hovered) {
      this.cardHover = hovered;
    },
    onMoveTimeToDifferentJob: function (jobNum, customer, description) {
      // display confirmation sweet alert
      Swal.fire({
        title: 'Are you sure you want to move this time?',
        html: `<ul class='swal-move-time'><li><span>Move time to:</span></li><li><span>Job -</span> #${jobNum}</li><li><span>Customer -</span> ${customer}</li><li><span>Description -</span> ${description}</li> </ul>`,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#74788d',
        confirmButtonText: 'Move Time',
        confirmButtonColor: '#556ee6',
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            // update jobNum for selected time to new jobNum
            firestore()
              .collection('times')
              .doc(this.moveTimeObj.id)
              .update({
                jobNum: jobNum,
                customer: customer
              })
              .then(() => {
                // Now update hourstabledata so change is made locally
                let index = this.hoursTableData.findIndex(
                  (x) => x['edit'] == this.moveTimeObj.id
                );
                // splice item from table
                this.hoursTableData.splice(index, 1);
                // hide modal
                this.$refs['modal-moveTime'].hide();

                Vue.$toast.open({
                  message: `Time successfully moved to Job #${jobNum}`,
                  type: 'success',
                  duration: 4000,
                  position: 'top-right',
                });
              })
              .catch((err) => {
                console.log(err);
                Swal.fire(
                  'Error!',
                  'An error was encountered when updating the times jobNum.',
                  'error'
                );
              });
          } catch (err) {
            console.log(err);
            Swal.fire(
              'Error!',
              'An error was encountered when transferring the time to a different job.',
              'error'
            );
          }
        }
      });
    },
    getAllJobs: function(){
      getJobs()
        .then((response) => {
          if (!response.empty) {
            response.forEach((doc) => {
              this.allOrgJobs.push({
                ...doc.data(),
                id: doc.id,
              });
            });
          }
        })
        .catch((err) => {
          Swal.fire(
            'Error!',
            `Error getting user's org jobs: ${err}`,
            'error'
          );
        });
    },
  },
  created: function () {
    this.getInitialSafetyForms();
    this.getAllJobs();
  },
  mounted: async function () {
    this.getJobDetails();
    await this.generateForm();
    await this.getTimes();
    await this.generateProductForm();
    await this.getBillableProducts();
    this.getEmployeesFunction();
    this.getProducts();
    this.getJobRates();
    this.jobDetailsLoaded = true;
    this.getCompanySettings();
    this.setTableSettings();
    getSpecificJobs('completed', '==', false)
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let dataObj = doc.data();
          dataObj['id'] = doc.id;
          this.orgJobs.push(dataObj);
        });
      })
      .catch((err) => {
        console.log(`Error getting organizations jobs`);
        console.log(err);
      });
  },
};
</script>

<style lang="scss" scoped>
.safety-form-card {
  border: 1px solid #eff2f7;
}
.safety-form-card:hover {
  cursor: pointer;
  transition: 0.2s ease-in;
  border-color: #556ee6;
  h5,
  p,
  i {
    color: #556ee6;
  }
}
.safety-form-view {
  h5 {
    &:first-of-type {
      margin-top: 0;
      font-style: italic;
      color: #919191;
    }
  }
  .safety-form-view-details {
    h5 {
      margin-bottom: -0.75rem;
      margin-top: 3rem;
      font-style: italic;
      color: #919191;
    }
    }
}

.swal-move-time {
  display: flex;
  flex-direction: column;
  text-align: start;
}
.swal-move-time li {
  list-style: none;
}
.swal-move-time span {
  font-weight: 500;
}
.move-time-modal-card-list {
  list-style: none;
}
.move-time-modal-card:hover {
  cursor: pointer;
  transition: 0.2s ease-in;
  border-color: #34c38f !important;
  h5 {
    transition: 0.2s ease-in;
    color: #34c38f !important;
  }
}
</style>
